"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
class AdAdapterBase {
  constructor(options, context) {
    this.options = options;
    this.context = context;
  }
  destroy() {
    this.options = null;
    this.context = null;
  }
  playClicked() {
  }
  getId() {
    return "base";
  }
  get info() {
    return {
      id: this.getId(),
      version: "",
      adTechnology: ""
    };
  }
  get adService() {
    return this.options.adService;
  }
  get player() {
    return this.context.player;
  }
  get aviaSdk() {
    return this.context.avia;
  }
  get csai() {
    return this.context.resource.ad.csai;
  }
  get logger() {
    return this.context.logger;
  }
  log(msg, obj) {
    this.logger.debug(`(${this.adService.getAdSystem()}): ${msg}`);
    if (obj) {
      for (const q in obj) {
        this.logger.debug(`${q}: ${obj[q]}`);
      }
    }
  }
}
class AdBreakSchedule {
  constructor(appContext, streamDur, timeConverter, cueTimes, cuePoints) {
    this.breaks = [];
    this.streamDuration = streamDur;
    this.appContext = appContext;
    if (cueTimes) {
      this.createBreaksFromTimes(cueTimes);
    } else if (cuePoints) {
      this.createBreaksFromCuepoints(cuePoints, timeConverter);
    }
  }
  destroy() {
    this.breaks = null;
    this.appContext = null;
  }
  getBreakById(id) {
    return this.breaks.find((b) => b.breakId === id);
  }
  get adBreaks() {
    return this.breaks;
  }
  // dai-specific
  updateBreaks(cues) {
    const played = [];
    let i = cues.length;
    while (i--) {
      cues[i].played && played.push(cues[i].start);
    }
    this.breaks.forEach((brk) => {
      if (!brk.hasPlayed && played.indexOf(brk.streamStartTime) >= 0) {
        brk.hasPlayed = true;
      }
    });
  }
  /**
  	 * Returns ad break for supplied time (in seconds) if there
  	 * is immediately preceding, un-played ad break.
  	 */
  getBreakForContentSeekTime(time) {
    return this.processMid((mid) => {
      if (mid.startTime <= time) {
        return !mid.hasPlayed ? mid : -1;
      }
      return null;
    });
  }
  hasPlayed(podId) {
    const b = this.getBreakById(podId);
    return (b == null ? void 0 : b.hasPlayed) === true;
  }
  markPlayed(b) {
    b.hasPlayed = true;
  }
  /**
  	 * fn must return a truthy value or -1 to break; null to continue loop
  	 */
  processMid(fn) {
    const mid = this.breaks.filter((b) => b.type === this.appContext.avia.AdBreakType.MID);
    if (!mid.length) {
      return null;
    }
    let i = mid.length, r;
    while (i--) {
      r = fn(mid[i]);
      if (r === -1) {
        return null;
      } else if (r) {
        return r;
      }
    }
    return null;
  }
  // DAI Cue points; value of  0 indicates a pre-roll.
  // These bracket the mid-roll times (which are in "content time").
  // dai case
  createBreaksFromCuepoints(cues, timeConverter) {
    const contentDur = timeConverter(this.streamDuration);
    let midIdx = 1, t, e, id, d, sst, brk;
    cues.sort(function(a, b) {
      return a.start - b.start;
    });
    let brkTimeTotal = 0;
    for (let i = 0, n = cues.length; i < n; i++) {
      t = cues[i].start;
      e = cues[i].end;
      d = e - t;
      sst = t;
      if (t - brkTimeTotal >= contentDur) {
        t = -1;
      }
      brkTimeTotal += d;
      id = this.makeBrkId(t, t > 0 ? midIdx++ : null);
      brk = this.makeBreak(timeConverter(sst), id, sst, this.appContext.avia.AdTechnology.SSAI);
      brk.endTime = e;
      brk.duration = d;
      this.addBreak(brk);
    }
  }
  // ima
  createBreaksFromTimes(cues) {
    let midIdx = 1, t, id;
    cues.sort(function(a, b) {
      return a - b;
    });
    for (let i = 0, n = cues.length; i < n; i++) {
      t = cues[i];
      id = this.makeBrkId(t, t > 0 ? midIdx++ : null);
      this.addBreak(this.makeBreak(t, id, null, this.appContext.avia.AdTechnology.CSAI));
    }
  }
  addBreak(brk) {
    this.breaks.push(brk);
  }
  makeBreak(t, id, sst = null, adTech) {
    const a = this.appContext.avia;
    return {
      adTechnology: adTech,
      startTime: t,
      hasPlayed: false,
      streamStartTime: sst != null ? sst : null,
      breakId: id,
      type: t === 0 ? a.AdBreakType.PRE : t === -1 ? a.AdBreakType.POST : a.AdBreakType.MID
    };
  }
  makeBrkId(t, idx) {
    const idPrefix = t === 0 ? "pre" : t === -1 ? "post" : "mid";
    return idPrefix + (t > 0 ? `_${idx}` : "_0");
  }
}
const FILTER_OUT_PREMIUM_AUDIO = "codec:ac-3,codec:ec-3";
const RAND_TOKEN = "[RANDOM]";
const SZ_PARAM = "sz";
const SZ_DEFAULT = "640x480";
const SZ_MUTED = "640x483";
const REFERER_KEY_SSAI = "imafw__fw_h_referer";
const HOST_KEY_SSAI = "imafw_host";
function processImaUrl(url, { muted }, skipHostAndReferer = false, versionInfo, templateFn) {
  if (muted) {
    url = url.replace(`${SZ_PARAM}=${SZ_DEFAULT}`, `${SZ_PARAM}=${SZ_MUTED}`);
  }
  return templateFn(url, {
    get RANDOM() {
      return rand16();
    },
    get HOST() {
      return getHost();
    },
    get REFERER() {
      return skipHostAndReferer ? "" : getReferer();
    },
    get PLAYERINFO() {
      return `${versionInfo.playername_version}`;
    },
    get SDK() {
      return `${versionInfo.ima_sdkv}`;
    }
  }, "\\[", "\\]");
}
function assembleStreamRequest(ssai, { muted }, skipHostAndReferer = false, versionInfo) {
  const params = processAdTagParameters(ssai, muted, skipHostAndReferer, versionInfo);
  const obj = {
    apiKey: ssai.apiKey,
    authToken: ssai.authToken || null,
    assetKey: ssai.assetKey || null,
    networkCode: ssai.networkCode || null,
    adTagParameters: params,
    videoId: ssai.videoId || null,
    contentSourceId: ssai.contentSourceId || null
  };
  if (ssai.format && typeof ssai.format === "string") {
    obj.format = ssai.format;
  }
  return obj;
}
function processAdTagParameters(config, muted, skipHostAndReferer, versionInfo) {
  const params = config.adParameters;
  const checkSz = muted;
  let hasHost = false;
  let hasRef = false;
  if (config.filterOutPremiumAudioCodecs) {
    params["dai-excl"] = FILTER_OUT_PREMIUM_AUDIO;
  }
  for (const q in params) {
    if (q === SZ_PARAM && checkSz && params[q] === SZ_DEFAULT) {
      params[q] = SZ_MUTED;
    }
    if (params[q] === RAND_TOKEN) {
      params[q] = rand16();
    }
    if (q === HOST_KEY_SSAI) {
      hasHost = true;
    }
    if (q === REFERER_KEY_SSAI) {
      hasRef = true;
    }
  }
  if (!skipHostAndReferer) {
    if (!hasHost) {
      params[HOST_KEY_SSAI] = getHost();
    }
    if (!hasRef) {
      params[REFERER_KEY_SSAI] = getReferer();
    }
  }
  for (const key in versionInfo) {
    if (/^imafw_/.test(key)) {
      params[key] = versionInfo[key];
    }
  }
  if (config.useApi === true) {
    for (const q in params) {
      params[q] = encodeURIComponent(params[q]);
    }
  }
  return params;
}
function enableOmFullAccess(req, sdk) {
  var _a;
  req.omidAccessModeRules = {};
  req.omidAccessModeRules[(_a = sdk.OmidAccessMode) == null ? void 0 : _a.FULL] = [new RegExp(".*")];
}
function rand16() {
  let n = String(Math.round(1e15 + Math.random() * 9e15));
  if (n.length < 16) {
    while (n.length < 16) {
      n += "0";
    }
  }
  if (n.length > 16) {
    n = n.substr(0, 17);
  }
  return n;
}
function getHost() {
  const hUrl = new URL(window.location.href);
  return hUrl.host;
}
function getReferer() {
  return (document == null ? void 0 : document.referrer) || "";
}
class DaiAdAdapter extends AdAdapterBase {
  constructor(options, context) {
    var _a;
    super(options, context);
    this.streamInfo = {
      mediaUrl: null,
      streamId: null
    };
    this.adBreakSchedule = null;
    this.streamDuration = NaN;
    this.contentDuration = NaN;
    this.breakMetadataPending = false;
    this.breaksReleased = false;
    this.adBreakInProgress = false;
    this.breakCount = 0;
    this.isIgnoringEvents = false;
    this.pendingStartTime = null;
    this.breakPending = false;
    this.omEnabled = true;
    this.adSegmentStarted = false;
    this.eventStallTimeoutHandle = null;
    this.eventStallTimeout = 5e3;
    this.paused = false;
    this.cachedAdTimes = [];
    this.breakReentered = false;
    this.currentAdIsSkippable = false;
    this.metadataTimeout = 2e3;
    this.currentTime = 0;
    this.onPlayPause = (e) => {
      switch (e.type) {
        case this.aviaSdk.PlayerEvent.AD_PAUSED:
        case this.aviaSdk.PlayerEvent.CONTENT_PAUSED:
          this.paused = true;
          this.clearTimeouts();
          break;
        case this.aviaSdk.PlayerEvent.AD_PLAYING:
        case this.aviaSdk.PlayerEvent.CONTENT_PLAYING:
          this.clearTimeouts();
          this.paused = false;
          break;
      }
    };
    this.onStreamEvent = (e) => {
      this.clearTimeouts();
      if (/cue/.test(e.type.toLowerCase()) && this.isIgnoringEvents) {
        this.processCuepoints(e);
      }
      if (!this.sdk || !this.adService || this.isIgnoringEvents) {
        return;
      }
      const evtType = e.type;
      const gamType = this.sdk.StreamEvent.Type;
      this.breakPending = false;
      let adSegmentJoined = false;
      switch (evtType) {
        case gamType.CUEPOINTS_CHANGED:
          this.processCuepoints(e);
          break;
        case gamType.AD_BREAK_STARTED:
          adSegmentJoined = true;
          this.breakPending = true;
          this.currentAdIsSkippable = false;
          this.breakMetadataPending = true;
          break;
        case gamType.STARTED:
          if (this.eventIsRegistered(evtType)) {
            return;
          }
          const ad = e.getAd();
          this.handleAdStart(ad, gamType.STARTED);
          break;
        case gamType.AD_PROGRESS:
          adSegmentJoined = true;
          if (this.adBreakInProgress) {
            const p = e.getStreamData().adProgressData;
            if (!this.breakTzero || isNaN(this.breakTzero)) {
              this.breakTzero = this.getBreakTzero();
            }
            if (this.eventIsRegistered(gamType.STARTED)) {
              this.sendProgress(p.currentTime, p.duration);
            }
          }
          break;
        case gamType.FIRST_QUARTILE:
          if (!this.validateLifecycleEvent(evtType, gamType.STARTED)) {
            return;
          }
          adSegmentJoined = true;
          if (this.adBreakInProgress) {
            this.registerEvent(evtType);
            this.trackQuartile(evtType);
            this.delegate.adFirstQuartile();
          }
          break;
        case gamType.MIDPOINT:
          if (!this.validateLifecycleEvent(evtType, gamType.FIRST_QUARTILE)) {
            return;
          }
          adSegmentJoined = true;
          if (this.adBreakInProgress) {
            this.registerEvent(evtType);
            this.trackQuartile(evtType);
            this.delegate.adMidpoint();
          }
          break;
        case gamType.THIRD_QUARTILE:
          if (!this.validateLifecycleEvent(evtType, gamType.MIDPOINT)) {
            return;
          }
          adSegmentJoined = true;
          if (this.adBreakInProgress) {
            this.registerEvent(evtType);
            this.trackQuartile(evtType);
            this.delegate.adThirdQuartile();
          }
          break;
        case gamType.COMPLETE:
          if (!this.validateLifecycleEvent(evtType, gamType.THIRD_QUARTILE)) {
            return;
          }
          this.resetAdLifecycleStatus();
          if (this.adBreakInProgress) {
            this.handleAdComplete(evtType);
          }
          break;
        case gamType.AD_BREAK_ENDED:
        case gamType.AD_PERIOD_ENDED:
          if (this.adBreakInProgress) {
            this.adBreakInProgress = false;
            this.delegate.adBreakComplete();
            this.endAdSegment();
            if (this.pendingStartTime) {
              this.delegate.seekToStreamTime(this.streamTimeForContentTime(this.pendingStartTime));
              this.pendingStartTime = null;
            }
          }
          this.resetAdLifecycleStatus();
          break;
        case gamType.CLICK:
          this.delegate.adClicked("");
          break;
        case gamType.SKIPPED:
          this.delegate.adSkipped();
          break;
        case gamType.SKIPPABLE_STATE_CHANGED:
          this.delegate.adSkippableStateChanged();
          break;
        case gamType.SHOW_AD_UI:
          const adUi = e.getAdUi();
          this.delegate.onShowAdUi(adUi);
          break;
        case gamType.HIDE_AD_UI:
          this.delegate.onHideAdUi();
          break;
        case gamType.ERROR:
          this.adBreakInProgress = false;
          this.log(`Error event SDK: ${e.getStreamData().errorMessage}`);
          this.signalError(e.getStreamData().errorMessage, this.aviaSdk.ErrorCode.DAI_DATA_ERROR, false);
          break;
      }
      if (adSegmentJoined) {
        this.startAdSegment();
      }
      this.signalAdSegmentEndAfterDelay();
    };
    this.omEnabled = options.enableOm;
    this.breakDetectionWindow = (_a = options.breakDetectionWindow) != null ? _a : 1.5;
    this.sdk = this.adService.sdk;
    this.streamManager = null;
    this.resetAdLifecycleStatus();
    this.delegate = context.getDelegate();
  }
  destroy() {
    var _a;
    this.clearTimeouts();
    (_a = this.streamManager) == null ? void 0 : _a.reset();
    this.listenToStreamManager(false);
    this.listenToPlayer(false);
    this.sdk = null;
    this.adBreakSchedule = null;
    this.streamManager = null;
    super.destroy();
  }
  replaceAdTagParameters(adTagParameters) {
    var _a, _b;
    (_b = (_a = this.streamManager).replaceAdTagParameters) == null ? void 0 : _b.call(_a, __spreadValues(__spreadValues({}, this.adTagParameters), adTagParameters));
  }
  ////////////////////////////////////////////////
  // Ad Adapter Interface impl
  skipAd() {
    const mgr = this.streamManager;
    if (!mgr) {
      return;
    }
    if (this.adService.usesDaiApi && this.currentAdIsSkippable === true) {
      this.currentAdIsSkippable = false;
      const seekTime = mgr.skipAd();
      this.resetAdLifecycleStatus();
      this.delegate.adSkipped();
      this.delegate.seekToStreamTime(seekTime);
    }
  }
  getId() {
    return GAM;
  }
  get info() {
    return {
      id: this.getId(),
      version: "",
      adTechnology: this.aviaSdk.AdTechnology.SSAI
    };
  }
  getResource() {
    return __async(this, null, function* () {
      var _a, _b;
      const { resource, logger } = this.context;
      const { ssai } = resource.ad || {};
      const { assetKey } = ssai || {};
      this.streamManager = this.adService.getStreamManager(this.breakDetectionWindow);
      this.listenToStreamManager(true);
      this.isIgnoringEvents = true;
      this.pendingStartTime = resource.playback.startTime || null;
      const { playerName, playerVersion } = this.context.buildInfo;
      const req = assembleStreamRequest(
        ssai,
        { muted: this.context.muted, autoplay: this.context.autoplay },
        this.adService.usesDaiApi || !this.context.system.isDesktop && !this.context.system.isMobile,
        {
          imafw_playername_version: `${playerName}_${playerVersion}`
        }
      );
      this.adTagParameters = __spreadValues({}, req.adTagParameters);
      try {
        logger.time(GamMeasurement.DAI_STREAM_METADATA_LOAD);
        if (assetKey) {
          const liveRequest = new this.sdk.LiveStreamRequest(req);
          this.setUiOptions(liveRequest, ssai);
          this.requestLiveStream(liveRequest);
        } else {
          if (resource.sessionId) {
            req.streamActivityMonitorId = resource.sessionId;
          }
          const vodRequest = new this.sdk.VODStreamRequest(req);
          this.setUiOptions(vodRequest, ssai);
          this.requestVODStream(vodRequest);
        }
        const event = yield this.aviaSdk.Util.eventsToPromise(
          [
            { target: this.streamManager, events: [this.sdk.StreamEvent.Type.LOADED] }
          ],
          [
            { target: this.streamManager, events: [this.sdk.StreamEvent.Type.ERROR] }
          ]
        );
        logger.timeEnd(GamMeasurement.DAI_STREAM_METADATA_LOAD);
        const d = event.getStreamData();
        const ok = this.initializeWithStreamData(d);
        this.isIgnoringEvents = false;
        if (!ok) {
          this.log("Media url not found in DAI stream response");
          throw new this.context.avia.PlayerError(
            this.aviaSdk.ErrorCode.DAI_DATA_ERROR,
            "Missing media url"
          );
        }
        this.log("Stream metadata loaded");
        if (resource.playback.startTime && !resource.ad.showPrerollOnNonZeroStart) {
          resource.playback.startTime = this.streamTimeForContentTime(resource.playback.startTime);
        } else if (resource.playback.startTime && resource.ad.showPrerollOnNonZeroStart) {
          const hasPreroll = ((_a = this.pendingCues) == null ? void 0 : _a.length) && this.pendingCues.find((q) => q.start === 0);
          if (hasPreroll) {
            resource.playback.startTime = NaN;
          } else {
            this.log("showPrerollOnNonZeroStart was set, but pre-roll is not available");
            resource.playback.startTime = this.streamTimeForContentTime(resource.playback.startTime);
          }
        }
        resource.location.mediaUrl = this.streamInfo.mediaUrl;
        return resource;
      } catch (error) {
        this.log("Stream request error, e");
        throw new this.context.avia.PlayerError(
          this.aviaSdk.ErrorCode.DAI_DATA_ERROR,
          ((_b = error.getStreamData()) == null ? void 0 : _b.errorMessage) || "Unspecified DAI error"
        );
      }
    });
  }
  start() {
    return __async(this, null, function* () {
      this.delegate.streamIdAvailable(this.streamInfo.streamId);
      this.delegate.resumeContent();
    });
  }
  handleTimedMetadata(md) {
    if (!/google/.test(md.id)) {
      return;
    }
    this.clearTimeouts();
    if (this.nonZeroStartPending && this.currentTime <= this.context.resource.playback.startTime) {
      return;
    }
    this.nonZeroStartPending = false;
    if (this.cachedAdTimes.length && this.shouldTrackReentry()) {
      if (this.isBreakReentry(md.startTime)) {
        this.breakReentered = true;
        this.delegate.adSegmentReentered();
      }
    }
    const obj = {
      TXXX: md.info
    };
    if (!this.breakReentered) {
      this.startAdSegment();
    }
    if (this.isLiveStream) {
      this.metadataTimeoutHandle = setTimeout(() => {
        if (!this.paused && !this.buffering_) {
          this.endAdSegment();
        }
      }, this.metadataTimeout);
    }
    this.streamManager.onTimedMetadata(obj);
  }
  contentTimeForStreamTime(t) {
    return this.streamManager.contentTimeForStreamTime(t);
  }
  streamTimeForContentTime(t) {
    return this.streamManager.streamTimeForContentTime(t);
  }
  getPermittedSeekTime(requestedContentSeekTime) {
    if (this.adBreakSchedule) {
      const b = this.adBreakSchedule.getBreakForContentSeekTime(requestedContentSeekTime);
      if (b && !b.hasPlayed) {
        b.hasPlayed = true;
        this.breakPending = true;
        this.breakTzero = b.streamStartTime;
        return b.streamStartTime;
      }
    }
    return this.streamManager.streamTimeForContentTime(requestedContentSeekTime);
  }
  setStreamTime(t) {
    var _a, _b;
    this.currentTime = t;
    this.adService.setCurrentTime(t);
    (_b = (_a = this.streamManager).onTimeUpdate) == null ? void 0 : _b.call(_a, t);
    if (!this.adBreakInProgress && !this.breakPending) {
      this.checkForAdSegment(t);
    }
  }
  setStreamDuration(v) {
    this.streamDuration = v;
    this.contentDuration = this.streamManager.contentTimeForStreamTime(v);
    this.adService.setDuration(v);
    if (this.pendingCues) {
      this.updateBreakSchedule(this.pendingCues);
    }
  }
  contentComplete() {
    this.streamManager.reset();
  }
  setBuffering(state) {
    if (state !== this.buffering_) {
      this.clearTimeouts();
    }
    this.buffering_ = state;
  }
  setVolume() {
  }
  setMuteState() {
  }
  setContentBitrate() {
  }
  updateSize() {
  }
  setFullscreenState() {
  }
  // END AdAdapterInterface impl
  /////////////////////////////////////////////////
  clearTimeouts() {
    clearTimeout(this.eventStallTimeoutHandle);
    clearTimeout(this.metadataTimeoutHandle);
  }
  shouldTrackReentry() {
    return this.isLiveStream && !this.player.isPlayingLive && !this.breakReentered;
  }
  isBreakReentry(time) {
    return this.cachedAdTimes.some((v) => time >= v[0] - 0.4 && time < v[1]);
  }
  signalAdSegmentEndAfterDelay() {
    if (this.adBreakInProgress && this.isLiveStream && !this.paused && !this.buffering_) {
      this.eventStallTimeoutHandle = setTimeout(() => {
        this.log(`No ad events have occurred for ${this.eventStallTimeout} sec.; ending ad segment.`);
        this.endAdSegment();
      }, this.eventStallTimeout);
    }
  }
  signalError(message, code, fatal) {
    this.delegate.adError({
      code: code || this.aviaSdk.ErrorCode.AD_ADAPTER_ERROR,
      message,
      cause: { streamId: this.streamInfo.streamId || null },
      fatal
    });
  }
  checkForAdSegment(streamTime) {
    var _a;
    const breaks = (_a = this.adBreakSchedule) == null ? void 0 : _a.adBreaks;
    const n = breaks == null ? void 0 : breaks.length;
    for (let i = 0; i < n; i++) {
      const q = breaks[i];
      const threshold = q.streamStartTime - 0.3;
      if (q.type === this.aviaSdk.AdBreakType.PRE) {
        continue;
      }
      if (q.hasPlayed && streamTime >= threshold && streamTime < q.streamStartTime + 5) {
        this.delegate.seekToStreamTime(q.endTime);
        break;
      }
    }
  }
  requestVODStream(requestObject, er = null) {
    if (this.omEnabled && this.adService.omEnabled) {
      enableOmFullAccess(requestObject, this.sdk);
    }
    if (this.context.resource.ad.ssai.enableNonce) {
      requestObject.enableNonce = true;
    }
    this.isLiveStream = false;
    this.streamManager.requestStream(requestObject, er);
  }
  requestLiveStream(requestObject, er = null) {
    if (this.omEnabled && this.adService.omEnabled) {
      enableOmFullAccess(requestObject, this.sdk);
    }
    if (this.context.resource.ad.ssai.enableNonce) {
      requestObject.enableNonce = true;
    }
    this.isLiveStream = true;
    this.streamManager.requestStream(requestObject, er);
  }
  setUiOptions(req, ssai) {
    if (this.adService.usesDaiApi) {
      return;
    }
    const { skippableSupport, aboutThisAdSupport, clickThroughNavigation, enabled } = ssai.customUiOptions || {};
    if (enabled) {
      req.ui.custom = new this.sdk.ui.UiOptions();
      const customUI = req.ui.custom;
      customUI.skippableSupport = skippableSupport;
      customUI.aboutThisAdSupport = aboutThisAdSupport;
      if (clickThroughNavigation) {
        if (clickThroughNavigation === ClickThroughNavigation.EXTERNAL) {
          customUI.clickThroughNavigation = this.sdk.ui.UiOptions.ClickThroughNavigation.EXTERNAL;
        } else if (clickThroughNavigation === ClickThroughNavigation.NOT_SUPPORTED) {
          customUI.clickThroughNavigation = this.sdk.ui.UiOptions.ClickThroughNavigation.NOT_SUPPORTED;
        }
      }
    }
  }
  validateLifecycleEvent(event, prevEvent) {
    if (event in this.adLifecycleStatus && prevEvent in this.adLifecycleStatus) {
      return this.eventIsRegistered(prevEvent) && !this.eventIsRegistered(event);
    }
    return false;
  }
  eventIsRegistered(event) {
    return this.adLifecycleStatus[event] === 1;
  }
  registerEvent(event) {
    if (event in this.adLifecycleStatus) {
      this.adLifecycleStatus[event] = 1;
    }
  }
  resetAdLifecycleStatus() {
    const gamEvent = this.sdk.StreamEvent.Type;
    this.adLifecycleStatus = {
      [gamEvent.STARTED]: 0,
      [gamEvent.FIRST_QUARTILE]: 0,
      [gamEvent.MIDPOINT]: 0,
      [gamEvent.THIRD_QUARTILE]: 0,
      [gamEvent.COMPLETE]: 0
    };
  }
  sendProgress(adTime, adDuration) {
    let breakTime;
    if (this.breakDuration && !isNaN(this.breakDuration)) {
      breakTime = this.getElapsedBreakTime();
    }
    this.delegate.adProgress(adTime, adDuration, breakTime, this.breakDuration);
  }
  processCuepoints(event) {
    const cues = event.getStreamData().cuepoints;
    if (this.contentDuration) {
      this.updateBreakSchedule(cues);
    } else {
      this.pendingCues = cues;
    }
  }
  startAdSegment() {
    if (!this.adSegmentStarted) {
      this.adSegmentStarted = true;
      this.delegate.adSegmentStarted();
    }
  }
  endAdSegment() {
    const tellDelegate = this.adSegmentStarted || this.breakReentered;
    this.clearTimeouts();
    this.resetAdLifecycleStatus();
    this.breakTzero = NaN;
    this.breakDuration = NaN;
    this.adSegmentStarted = false;
    this.breakReentered = false;
    if (tellDelegate) {
      this.delegate.adSegmentEnded();
    }
  }
  handleAdComplete(evt) {
    this.currentAdIsSkippable = false;
    if (this.isLiveStream && this.adStartTime !== null) {
      this.cachedAdTimes.push([
        this.adStartTime,
        this.currentTime
      ]);
      this.adStartTime = null;
    }
    if (!this.adService.usesDaiApi) {
      this.adService.trackAdEvent({
        context: this.adService.getAdSystem(),
        eventName: evt,
        volume: this.adService.videoInterface.volume
      });
      this.adService.untrackAd();
    }
    this.delegate.adComplete();
  }
  trackQuartile(evt) {
    !this.adService.usesDaiApi && this.adService.trackAdEvent({
      context: this.adService.getAdSystem(),
      eventName: evt,
      volume: this.adService.videoInterface.volume
    });
  }
  getElapsedBreakTime() {
    if (this.isLiveStream) {
      return (this.player.liveStreamUtcTime - this.breakTzero) * 1e-3;
    } else {
      return this.player.streamTime - this.breakTzero;
    }
  }
  getBreakTzero() {
    return this.isLiveStream ? this.player.liveStreamUtcTime : this.player.streamTime;
  }
  handleAdStart(ad, evt) {
    return __async(this, null, function* () {
      var _a, _b, _c, _d, _e;
      const abi = (_a = this.adService) == null ? void 0 : _a.assembleAdBreakInfo(ad, this.aviaSdk.AdTechnology.SSAI);
      const ai = (_b = this.adService) == null ? void 0 : _b.assembleAdInfo(ad, { mediaUrl: this.streamInfo.mediaUrl });
      if (this.breakMetadataPending || !this.adBreakInProgress) {
        this.breakMetadataPending = false;
        if (this.isLiveStream) {
          abi.adBreakPosition = ++this.breakCount;
          abi.adBreakType = this.aviaSdk.AdBreakType.MID;
        }
        this.startAdSegment();
        if (!this.adBreakInProgress) {
          this.markBreakPlayed(abi);
          this.delegate.adBreakStart();
        }
        abi.adTechnology = this.aviaSdk.AdTechnology.SSAI;
        this.breakDuration = abi.adBreakDuration;
        this.delegate.adBreakMetadata(abi);
      }
      this.adStartTime = this.currentTime;
      this.breakReentered = false;
      this.adBreakInProgress = true;
      if (!this.adService.usesDaiApi) {
        this.adService.trackAd(ai);
        this.adService.trackAdEvent({
          context: this.adService.getAdSystem(),
          eventName: evt,
          volume: this.adService.videoInterface.volume
        });
      }
      const { skippable } = yield this.delegate.applyHook(this.aviaSdk.PlayerHookType.AD, __spreadValues({ skippable: false }, ai));
      this.currentAdIsSkippable = skippable;
      ai.skippable = skippable;
      this.registerEvent((_c = this.sdk) == null ? void 0 : _c.StreamEvent.Type.STARTED);
      (_d = this.delegate) == null ? void 0 : _d.adStart(ai);
      if (this.paused) {
        (_e = this.delegate) == null ? void 0 : _e.adPaused();
      }
    });
  }
  markBreakPlayed(adBreak) {
    var _a;
    if (!((_a = this.adBreakSchedule) == null ? void 0 : _a.adBreaks)) {
      return;
    }
    const start = Math.round(adBreak.streamStartTime);
    const brk = this.adBreakSchedule.adBreaks.find((b) => Math.round(b.streamStartTime) === start);
    if (brk) {
      brk.hasPlayed = true;
    }
  }
  initializeWithStreamData(data) {
    const assetUrl = data.url;
    if (!this.aviaSdk.Util.isString(assetUrl) || assetUrl === "") {
      return false;
    }
    const sid = data.streamId;
    this.streamInfo.mediaUrl = assetUrl;
    this.streamInfo.streamId = sid;
    this.listenToPlayer(true);
    return true;
  }
  listenToPlayer(flag) {
    const p = this.player;
    if (!p) {
      return;
    }
    const method = flag ? "on" : "off";
    const evt = this.aviaSdk.PlayerEvent;
    const evts = [evt.AD_PAUSED, evt.CONTENT_PAUSED, evt.AD_PLAYING, evt.CONTENT_PLAYING];
    evts.forEach((e) => p[method](e, this.onPlayPause));
  }
  listenToStreamManager(flag) {
    const m = flag ? "addEventListener" : "removeEventListener";
    const evts = this.getEventInterests();
    evts.forEach((evt) => {
      this.streamManager[m](evt, this.onStreamEvent);
    });
  }
  getEventInterests() {
    const t = this.sdk.StreamEvent.Type;
    return [
      t.CUEPOINTS_CHANGED,
      t.AD_BREAK_STARTED,
      t.AD_BREAK_ENDED,
      t.STARTED,
      t.COMPLETE,
      t.AD_PERIOD_STARTED,
      t.AD_PERIOD_ENDED,
      t.AD_PROGRESS,
      t.FIRST_QUARTILE,
      t.MIDPOINT,
      t.THIRD_QUARTILE,
      t.SKIPPED,
      t.SKIPPABLE_STATE_CHANGED,
      t.CLICK,
      t.ERROR,
      t.SHOW_AD_UI,
      t.HIDE_AD_UI
    ];
  }
  cleanUpAfterBreaksCreated(showPrerollOnNonZeroStart) {
    this.pendingCues = null;
    if (!showPrerollOnNonZeroStart) {
      this.pendingStartTime = null;
    }
  }
  updateBreakSchedule(cues) {
    var _a;
    const valid = cues && cues.length;
    const rsc = this.context.resource;
    const showPrerollOnNonZeroStart = rsc.ad.showPrerollOnNonZeroStart;
    let brks = [];
    if (valid && !this.adBreakSchedule) {
      this.adBreakSchedule = new AdBreakSchedule(
        this.context,
        this.streamDuration,
        (t) => this.streamManager.contentTimeForStreamTime(t),
        null,
        cues
      );
      brks = this.adBreakSchedule.adBreaks;
      let i = brks.length;
      while (i--) {
        const bk = brks[i];
        if (bk.startTime < this.pendingStartTime && bk.type !== this.aviaSdk.AdBreakType.POST) {
          bk.hasPlayed = true;
          break;
        }
      }
    } else if (valid) {
      (_a = this.adBreakSchedule) == null ? void 0 : _a.updateBreaks(cues);
    }
    if (this.pendingStartTime && !showPrerollOnNonZeroStart) {
      this.nonZeroStartPending = true;
      const b0 = brks[0];
      if ((b0 == null ? void 0 : b0.type) === this.aviaSdk.AdBreakType.PRE) {
        b0.hasPlayed = true;
      }
    }
    if (!this.breaksReleased) {
      this.breaksReleased = true;
      this.cleanUpAfterBreaksCreated(showPrerollOnNonZeroStart);
      this.delegate.adBreaksAvailable(brks);
      return;
    }
  }
}
var AdSystem = /* @__PURE__ */ ((AdSystem2) => {
  AdSystem2["IMA"] = "ima";
  AdSystem2["DAI_SDK"] = "dai_sdk";
  AdSystem2["DAI_API"] = "dai_api";
  return AdSystem2;
})(AdSystem || {});
class ImaAdAdapter extends AdAdapterBase {
  constructor(options, context) {
    super(options, context);
    this.isFullscreen = false;
    this.inProgressAd = null;
    this.inProgressBreakId = null;
    this.isPaused = false;
    this.buffering_ = false;
    this.breakMetadataReleased = false;
    this.breakStartReleased = false;
    this.pendingSeekedBreakId = null;
    this.markedAsPlayed = [];
    this.adProgressData = {
      lastRecordedTime: 0,
      addTzero: null,
      pollTzero: null,
      timeoutHandle: null,
      stallThreshold: 5,
      adId: null,
      duration: null,
      pollInterval: 2e3
    };
    this.hAdsManagerAdError = (e) => {
      const err = this.adService.parseAdError(e);
      this.log("AdsManager ERROR", err);
      this.delegate.adError({
        code: this.aviaSdk.ErrorCode.IMA_AD_ERROR,
        message: err == null ? void 0 : err.message,
        cause: err,
        fatal: false
      });
    };
    this.hAdEvent = (e) => {
      const t = this.sdk.AdEvent.Type;
      const ad = e.getAd();
      const adData = e.getAdData();
      clearTimeout(this.adProgressData.timeoutHandle);
      let restartPoll = this.csai.enableStalledAdCheck !== false;
      switch (e.type) {
        case t.CONTENT_PAUSE_REQUESTED:
          restartPoll = false;
          this.pendingSeekedBreakId = null;
          this.delegate.pauseContent();
          break;
        case t.CONTENT_RESUME_REQUESTED:
          restartPoll = false;
          if (this.inProgressBreakId) {
            this.pendingSeekedBreakId = null;
            this.processBreakComplete(this.breakStartReleased);
          } else {
            this.delegate.resumeContent();
          }
          break;
        case t.LOADED:
          restartPoll = false;
          this.processAdLoadOrStart(ad, adData, t.LOADED);
          break;
        case t.STARTED:
          restartPoll = false;
          if (this.inProgressBreakId && !this.breakStartReleased) {
            this.breakStartReleased = true;
            this.delegate.adBreakStart();
          }
          this.processAdLoadOrStart(ad, adData, t.STARTED);
          this.checkForCustomClickTracking();
          this.beginPollForProgress(this.inProgressAd);
          break;
        case t.AD_PROGRESS:
          if (this.buffering_) {
            this.buffering_ = false;
            this.delegate.adBuffering(false);
          }
          this.processProgress();
          break;
        case t.FIRST_QUARTILE:
          this.processQuartile(t.FIRST_QUARTILE, "adFirstQuartile");
          break;
        case t.MIDPOINT:
          this.processQuartile(t.MIDPOINT, "adMidpoint");
          break;
        case t.THIRD_QUARTILE:
          this.processQuartile(t.THIRD_QUARTILE, "adThirdQuartile");
          break;
        case t.COMPLETE:
          restartPoll = false;
          this.processAdComplete(t.COMPLETE);
          break;
        case t.ALL_ADS_COMPLETED:
          restartPoll = false;
          this.processAllComplete();
          break;
        case t.AD_BUFFERING:
          if (!this.buffering_) {
            this.buffering_ = true;
            this.delegate.adBuffering(true);
          }
          break;
        case t.CLICK:
          restartPoll = false;
          this.adsManager.pause();
          this.delegate.adClicked("");
          break;
        case t.PAUSED:
          restartPoll = false;
          this.isPaused = true;
          this.delegate.adPaused();
          break;
        case t.RESUMED:
          if (this.buffering_) {
            this.buffering_ = false;
            this.delegate.adBuffering(false);
          }
          this.isPaused = false;
          this.delegate.adResumed();
          break;
        case t.SKIPPED:
          restartPoll = false;
          this.processSkip(t.SKIPPED);
          break;
        case t.LOG:
          restartPoll = false;
          this.processLogEvent(adData);
          break;
        case t.USER_CLOSE:
          restartPoll = false;
          this.killAd();
          break;
        case t.VOLUME_CHANGED:
        case t.VOLUME_MUTED:
          this.processVolumeChange(e.type);
          break;
      }
      if (!this.isPaused && restartPoll) {
        this.adProgressData.timeoutHandle = setTimeout(
          () => this.checkAdProgress(),
          this.adProgressData.pollInterval
        );
      }
    };
    this.delegate = context.getDelegate();
    this.presentationContainer = options.presentationContainer;
    this.sdk = this.adService.sdk;
    this.adsLoader = this.adService.adsLoader;
    this.adProgressData.stallThreshold = this.csai.stalledAdThreshold || this.adProgressData.stallThreshold;
    this.listenToAdsLoader(true);
  }
  destroy() {
    var _a, _b;
    clearTimeout(this.adProgressData.timeoutHandle);
    this.listenToAdsLoader(false);
    this.listenToAdsManager(false);
    (_a = this.adsManager) == null ? void 0 : _a.destroy();
    (_b = this.adsLoader) == null ? void 0 : _b.contentComplete();
    this.adBreakSchedule && this.adBreakSchedule.destroy();
    this.delegate = null;
    this.presentationContainer = null;
    this.adsManager = null;
    this.sdk = null;
    this.adsLoader = null;
    this.adBreakSchedule = null;
    this.renderingSettings = null;
    super.destroy();
  }
  ////////////////////////////////////////////////
  // Ad Adapter Interface
  skipAd() {
  }
  getId() {
    return GAM;
  }
  get info() {
    return {
      id: this.getId(),
      version: this.adsLoader.getSdkVersion(),
      adTechnology: this.aviaSdk.AdTechnology.CSAI
    };
  }
  playClicked() {
    this.adService.initializeAdsLoader();
  }
  start() {
    return __async(this, null, function* () {
      const url = this.csai.adCallUrl;
      if (!url && !this.csai.adsResponse) {
        this.delegate.resumeContent();
        return;
      }
      this.adService.initializeAdsLoader();
      this.initialize(url);
    });
  }
  resume() {
    return __async(this, null, function* () {
      var _a;
      clearTimeout(this.adProgressData.timeoutHandle);
      this.isPaused = false;
      (_a = this.adsManager) == null ? void 0 : _a.resume();
    });
  }
  pause() {
    return __async(this, null, function* () {
      var _a;
      clearTimeout(this.adProgressData.timeoutHandle);
      this.isPaused = true;
      (_a = this.adsManager) == null ? void 0 : _a.pause();
    });
  }
  handleTimedMetadata() {
  }
  // dupe, see below for impl
  updateSize(dimensions) {
    if (this.adsManager) {
      const vm = this.isFullscreen ? this.sdk.ViewMode.FULLSCREEN : this.sdk.ViewMode.NORMAL;
      this.adsManager.resize(dimensions.width, dimensions.height, vm);
    }
  }
  contentComplete() {
    var _a;
    (_a = this.adsLoader) == null ? void 0 : _a.contentComplete();
  }
  getPermittedSeekTime(requestedContentSeekTime) {
    var _a;
    const b = (_a = this.adBreakSchedule) == null ? void 0 : _a.getBreakForContentSeekTime(requestedContentSeekTime);
    if (b && this.markedAsPlayed.indexOf(b.breakId) === -1) {
      this.pendingSeekedBreakId = b.breakId;
      return b.startTime;
    }
    return requestedContentSeekTime;
  }
  setFullscreenState(value) {
    this.isFullscreen = value;
  }
  setStreamTime() {
  }
  setStreamDuration() {
  }
  setVolume(volume) {
    var _a;
    const value = this.player.muted ? 0 : this.aviaSdk.Util.clampValue(volume, 0, 1);
    (_a = this.adsManager) == null ? void 0 : _a.setVolume(value);
  }
  setMuteState(muted) {
    var _a;
    (_a = this.adsManager) == null ? void 0 : _a.setVolume(muted ? 0 : this.player.volume);
  }
  setContentBitrate(value) {
    var _a;
    if (this.renderingSettings) {
      this.renderingSettings.bitrate = value;
      (_a = this.adsManager) == null ? void 0 : _a.updateAdsRenderingSettings(this.renderingSettings);
    }
  }
  // END
  /////////////////////////////////////////////////
  startAds() {
    var _a;
    const rect = this.getRect(), view = this.isFullscreen ? this.sdk.ViewMode.FULLSCREEN : this.sdk.ViewMode.NORMAL;
    try {
      this.adsManager.init(rect.width, rect.height, view);
      this.adsManager.start();
    } catch (adError) {
      this.log("AdsManager init failure.");
      this.delegate.adError({
        code: this.aviaSdk.ErrorCode.IMA_INIT_FAILURE,
        message: (_a = adError.getMessage) == null ? void 0 : _a.call(adError),
        cause: adError,
        fatal: false
      });
    }
  }
  markAsPlayed(ids) {
    ids.forEach((id) => {
      if (this.markedAsPlayed.indexOf(id) < 0) {
        this.markedAsPlayed.push(id);
      }
    });
  }
  cancelPendingBreak(id) {
    this.pendingSeekedBreakId === id && (this.pendingSeekedBreakId = null);
  }
  isUsingContentVideoElement() {
    return this.adsManager && this.adsManager.isCustomPlaybackUsed();
  }
  isUsingCustomClickTracker() {
    return !!(this.adsManager && this.adsManager.isCustomClickTrackingUsed());
  }
  setContentComplete() {
    this.adsLoader && this.adsLoader.contentComplete();
  }
  checkForCustomClickTracking() {
    if (this.isUsingCustomClickTracker()) {
      this.delegate.displayAdClickElement(true);
    }
  }
  beginPollForProgress(ad) {
    if (this.csai.enableStalledAdCheck !== true) {
      return;
    }
    const apd = this.adProgressData;
    clearTimeout(apd.timeoutHandle);
    apd.duration = ad.adDuration;
    apd.adId = ad.adId;
    apd.pollTzero = Date.now();
    apd.timeoutHandle = setTimeout(() => this.checkAdProgress(), apd.pollInterval);
  }
  checkAdProgress() {
    const apd = this.adProgressData, currT = apd.duration - this.adsManager.getRemainingTime(), now = Date.now();
    clearTimeout(apd.timeoutHandle);
    if (this.isPaused) {
      return;
    }
    if (apd.pollTzero == null) {
      apd.pollTzero = Date.now();
    }
    if (currT > apd.lastRecordedTime) {
      apd.lastRecordedTime = currT;
      apd.pollTzero = now;
      apd.timeoutHandle = setTimeout(() => this.checkAdProgress(), apd.pollInterval);
    } else if ((now - apd.pollTzero) * 1e-3 > apd.stallThreshold) {
      const adInfo = this.inProgressAd ? Object.assign({}, this.inProgressAd) : null;
      this.log("Ad stalled; discarding break");
      this.delegate.adStalled(adInfo);
      this.killAd();
      this.discardAdBreak();
      this.processBreakComplete(this.breakStartReleased);
    }
  }
  ////////////////////
  // Event processors - process IMA events, dispatch an ImaAdPlayer.event
  // Process ad break for both start and loaded (some info may only be avail at start, vs load)
  processAdLoadOrStart(ad, adData, evt) {
    var _a;
    const abi = this.adService.assembleAdBreakInfo(ad, this.aviaSdk.AdTechnology.CSAI);
    const ai = this.adService.assembleAdInfo(ad, adData);
    const isStart = evt === this.sdk.AdEvent.Type.STARTED;
    const idx = abi.adBreakPosition;
    const id = idx === 0 ? "pre_0" : idx === -1 ? "post_0" : "mid_" + idx;
    const adBreak = this.adBreakSchedule.getBreakById(id);
    if (((_a = this.markedAsPlayed) == null ? void 0 : _a.indexOf(id)) >= 0) {
      this.adBreakSchedule.markPlayed(adBreak);
      this.adsManager.discardAdBreak();
      return;
    }
    if (isStart) {
      this.inProgressAd = ai;
      this.adService.trackAd(ai);
      this.adService.trackAdEvent({
        context: AdSystem.IMA,
        eventName: evt,
        volume: this.adsManager.getVolume()
      });
      abi.adTechnology = this.aviaSdk.AdTechnology.CSAI;
      if (!this.breakMetadataReleased) {
        this.breakMetadataReleased = true;
        this.delegate.adBreakMetadata(abi);
      }
      this.delegate.adStart(ai);
    } else {
      if (!this.adBreakSchedule.hasPlayed(id)) {
        this.adBreakSchedule.markPlayed(adBreak);
        this.inProgressBreakId = id;
        this.delegate.adLoaded();
      }
    }
  }
  processProgress() {
    if (!this.inProgressAd) {
      return;
    }
    const dur = this.inProgressAd.adDuration;
    const tRem = this.adsManager && this.adsManager.getRemainingTime();
    if (isNaN(dur) || isNaN(tRem) || tRem < 0) {
      return;
    }
    this.delegate.adProgress(Math.min(dur, Math.max(0, dur - tRem)), dur);
  }
  processQuartile(imaEvent, delegateMethod) {
    var _a;
    this.adService.trackAdEvent({
      context: AdSystem.IMA,
      eventName: imaEvent,
      volume: this.adsManager.getVolume()
    });
    (_a = this.delegate) == null ? void 0 : _a[delegateMethod]();
  }
  processAdComplete(imaEvt) {
    this.adService.trackAdEvent({
      context: AdSystem.IMA,
      eventName: imaEvt,
      volume: this.adsManager.getVolume()
    });
    this.killAd();
  }
  processSkip(imaEvt) {
    this.adService.trackAdEvent({
      context: AdSystem.IMA,
      eventName: imaEvt,
      volume: this.adsManager.getVolume()
    });
    this.killAd();
    this.delegate.adSkipped();
  }
  processBreakComplete(sendBreakComplete = true) {
    if (this.inProgressAd) {
      this.killAd();
    }
    if (this.inProgressBreakId) {
      this.markAsPlayed([this.inProgressBreakId]);
      if (sendBreakComplete) {
        this.delegate.adBreakComplete();
      }
      this.inProgressBreakId = null;
    }
    this.breakStartReleased = false;
    this.breakMetadataReleased = false;
    this.delegate.resumeContent();
  }
  processVolumeChange(imaEvtType) {
    this.adService.trackAdEvent({
      context: AdSystem.IMA,
      eventName: imaEvtType,
      volume: this.adsManager.getVolume()
    });
  }
  processAllComplete() {
    if (this.inProgressBreakId) {
      this.processBreakComplete();
    }
    this.delegate.allAdsComplete();
  }
  processLogEvent(adData) {
    if (adData == null ? void 0 : adData.adError) {
      this.log("LOG event; Ad data has error; Message: " + adData.adError.getMessage() || "no message available");
      let brkId = null;
      if (this.pendingSeekedBreakId || this.inProgressBreakId) {
        brkId = this.pendingSeekedBreakId || this.inProgressBreakId;
      } else {
        const t = this.player.contentTime;
        const b = this.findClosestForwardBreak(t);
        if (b) {
          this.adBreakSchedule.markPlayed(b);
          brkId = b.breakId;
        }
      }
      if (brkId) {
        this.markAsPlayed([brkId]);
      }
      this.delegate.adError({
        code: this.aviaSdk.ErrorCode.IMA_AD_ERROR,
        message: adData.adError.getMessage(),
        cause: adData.adError,
        fatal: false
      });
      this.discardAdBreak();
      this.delegate.resumeContent();
    }
  }
  findClosestForwardBreak(time) {
    const b = this.adBreakSchedule.adBreaks;
    for (let i = 0, n = b.length; i < n; i++) {
      if (b[i].startTime >= time && b[i].startTime - time <= 10) {
        return b[i];
      }
    }
    return null;
  }
  discardAdBreak() {
    var _a;
    this.log("Discarding Ad break");
    this.delegate.adBreakDiscarded();
    (_a = this.adsManager) == null ? void 0 : _a.discardAdBreak();
  }
  // end Event Processors
  ///////////////////////
  killAd() {
    this.adService.untrackAd();
    this.delegate.adComplete();
    this.delegate.displayAdClickElement(false);
    this.inProgressAd = null;
    const apd = this.adProgressData;
    clearTimeout(apd.timeoutHandle);
    apd.pollTzero = null;
    apd.lastRecordedTime = null;
  }
  requestAds(url) {
    const ar = new this.sdk.AdsRequest();
    const r = this.getRect();
    const aps = this.options.autoplayState;
    const skipHost = !(this.context.system.isDesktop || this.context.system.isMobile);
    const templateFn = this.context.avia.Util.template;
    if (typeof this.csai.adsResponse == "string" || this.csai.adsResponse instanceof XMLDocument) {
      this.log("IMAAdAdapter using supplied adsResponse (i.e., not using adCallUrl)");
      ar.adsResponse = this.csai.adsResponse;
    } else {
      const { playerName, playerVersion } = this.context.buildInfo;
      const u = processImaUrl(
        url,
        aps,
        skipHost,
        {
          ima_sdkv: this.adsLoader.getSdkVersion(),
          playername_version: `${playerName}_${playerVersion}`
        },
        templateFn
      );
      ar.adTagUrl = u;
    }
    ar.linearAdSlotWidth = r.width;
    ar.linearAdSlotHeight = r.height;
    ar.nonLinearAdSlotWidth = r.width;
    ar.nonLinearAdSlotHeight = r.height;
    ar.vastLoadTimeout = this.csai.vastLoadTimeout || 5e3;
    ar.setAdWillAutoPlay(aps.autoplay);
    ar.setAdWillPlayMuted(aps.muted);
    this.adsLoader.requestAds(ar);
  }
  // Ads Mgr Loaded
  hAdsMgrLoaded(e) {
    this.renderingSettings = this.getRenderingSettings();
    this.adsManager = e.getAdsManager(this.options.playheadInterface, this.renderingSettings);
    this.createAdBreakSchedule(this.adsManager.getCuePoints());
    this.listenToAdsManager(true);
    this.startAds();
  }
  getRenderingSettings() {
    const rs = new this.sdk.AdsRenderingSettings();
    const cfg = this.csai;
    const defs = this.adService.defaultRenderingSettings;
    const sTimeout = cfg.loadVideoTimeoutMs;
    const sPreLoadAds = cfg.enableAdPreloading;
    rs.bitrate = defs.bitrate;
    rs.enablePreloading = this.aviaSdk.Util.isBoolean(sPreLoadAds) ? sPreLoadAds : defs.enablePreloading;
    rs.loadVideoTimeout = !isNaN(sTimeout) ? sTimeout : defs.loadVideoTimeout;
    rs.restoreCustomPlaybackStateOnAdBreakComplete = defs.restoreCustomPlaybackStateOnAdBreakComplete;
    return rs;
  }
  createAdBreakSchedule(cuePoints) {
    if (this.aviaSdk.Util.isEmpty(cuePoints)) {
      cuePoints = [0];
    }
    this.adBreakSchedule = new AdBreakSchedule(this.context, null, (t) => t, cuePoints);
    this.checkNonZeroStart();
    this.delegate.adBreaksAvailable(this.adBreakSchedule.adBreaks);
  }
  checkNonZeroStart() {
    const { resource } = this.context;
    const contentStartTime = resource.playback.startTime;
    const nonZeroStart = !isNaN(contentStartTime) && contentStartTime > 0;
    if (!nonZeroStart) {
      return;
    }
    const bks = this.adBreakSchedule.adBreaks;
    let i = bks.length;
    while (i--) {
      const bk = bks[i];
      if (bk.startTime < contentStartTime && bk.type === this.aviaSdk.AdBreakType.MID) {
        bk.hasPlayed = true;
        this.markedAsPlayed.push(bk.breakId);
        break;
      }
    }
    const showPreRoll = resource.ad.showPrerollOnNonZeroStart;
    bks.forEach((b) => {
      if (b.type === this.aviaSdk.AdBreakType.PRE && !showPreRoll) {
        this.markedAsPlayed.push(b.breakId);
        this.adBreakSchedule.markPlayed(b);
      }
    });
  }
  hAdsLoaderError(error) {
    this.log("AdsLoader ERROR", error);
    this.delegate.adError({
      code: this.aviaSdk.ErrorCode.IMA_AD_ERROR,
      message: error.message,
      cause: error,
      fatal: false
    });
    this.delegate.resumeContent();
  }
  listenToAdsManager(flag) {
    if (!this.adsManager) {
      return;
    }
    const m = flag ? "addEventListener" : "removeEventListener";
    const events = this.getEventInterests();
    let event;
    for (let i = 0, n = events.length; i < n; i++) {
      event = this.sdk.AdEvent.Type[events[i]];
      this.adsManager[m](event, this.hAdEvent);
    }
    this.adsManager[m](this.sdk.AdErrorEvent.Type.AD_ERROR, this.hAdsManagerAdError);
  }
  listenToAdsLoader(flag) {
    this.adsLoader.onAdsLoaderError = flag ? (e) => this.hAdsLoaderError(e) : null;
    this.adsLoader.onAdsManagerLoaded = flag ? (e) => this.hAdsMgrLoaded(e) : null;
  }
  getEventInterests() {
    return [
      "CONTENT_PAUSE_REQUESTED",
      "CONTENT_RESUME_REQUESTED",
      "LOADED",
      "STARTED",
      "AD_PROGRESS",
      "FIRST_QUARTILE",
      "MIDPOINT",
      "THIRD_QUARTILE",
      "COMPLETE",
      "ALL_ADS_COMPLETED",
      "AD_BUFFERING",
      "CLICK",
      "PAUSED",
      "RESUMED",
      "SKIPPED",
      "LOG",
      "USER_CLOSE"
    ];
  }
  getRect() {
    return this.presentationContainer.getBoundingClientRect();
  }
  initialize(url) {
    this.listenToAdsLoader(true);
    this.requestAds(url);
  }
}
const defaultFormat$1 = "hls";
class LiveStreamRequest {
  constructor(reqParams) {
    this.req = reqParams;
  }
  set adTagParameters(val) {
    this.req.adTagParameters = val;
  }
  get adTagParameters() {
    return this.req.adTagParameters;
  }
  set apiKey(val) {
    this.req.apiKey = val;
  }
  get apiKey() {
    return this.req.apiKey;
  }
  set authToken(val) {
    this.req.authToken = val;
  }
  get authToken() {
    return this.req.authToken;
  }
  set format(val) {
    this.req.format = val;
  }
  get format() {
    return this.req.format || defaultFormat$1;
  }
  set assetKey(val) {
    this.req.assetKey = val;
  }
  get assetKey() {
    return this.req.assetKey;
  }
}
const _StreamEvent = class _StreamEvent {
  constructor(type, target, streamData, ad) {
    this.defaultPrevented = false;
    this.ad = null;
    this.type = type;
    this.data = streamData;
    this.detail = this.data;
    this.target = target;
    ad && (this.ad = ad);
  }
  preventDefault() {
  }
  get Type() {
    return _StreamEvent.Type;
  }
  getAd() {
    return this.ad;
  }
  getAdUi() {
    return null;
  }
  getStreamData() {
    return this.data;
  }
};
_StreamEvent.Type = {
  LOADED: "loaded",
  AD_BREAK_STARTED: "adBreakStarted",
  AD_BREAK_ENDED: "adBreakEnded",
  STARTED: "started",
  COMPLETE: "complete",
  FIRST_QUARTILE: "firstQuartile",
  MIDPOINT: "midpoint",
  THIRD_QUARTILE: "thirdQuartile",
  AD_PERIOD_STARTED: "adPeriodStarted",
  AD_PERIOD_ENDED: "adPeriodEnded",
  CUEPOINTS_CHANGED: "cuePointsChanged",
  STREAM_INITIALIZED: "streamInitialized",
  SKIPPED: "adskipped",
  SKIPPABLE_STATE_CHANGED: "skippablestatechanged",
  ERROR: "error",
  AD_PROGRESS: "adProgress",
  CLICK: "click",
  SHOW_AD_UI: "showadui",
  HIDE_AD_UI: "hideadui"
};
let StreamEvent = _StreamEvent;
const defaultFormat = "hls";
class VODStreamRequest {
  constructor(reqParams) {
    this.req = reqParams;
  }
  set streamActivityMonitorId(val) {
    this.req.streamActivityMonitorId = val;
  }
  get streamActivityMonitorId() {
    return this.req.streamActivityMonitorId;
  }
  set adTagParameters(val) {
    this.req.adTagParameters = val;
  }
  get adTagParameters() {
    return this.req.adTagParameters;
  }
  set videoId(val) {
    this.req.videoId = val;
  }
  get videoId() {
    return this.req.videoId;
  }
  set contentSourceId(val) {
    this.req.contentSourceId = val;
  }
  get contentSourceId() {
    return this.req.contentSourceId;
  }
  set apiKey(val) {
    this.req.apiKey = val;
  }
  get apiKey() {
    return this.req.apiKey;
  }
  set authToken(val) {
    this.req.authToken = val;
  }
  get authToken() {
    return this.req.authToken;
  }
  set format(val) {
    this.req.format = val;
  }
  get format() {
    return this.req.format || defaultFormat;
  }
  set assetKey(val) {
    this.req.assetKey = val;
  }
  get assetKey() {
    return this.req.assetKey;
  }
}
const se = StreamEvent;
const vr = VODStreamRequest;
const lr = LiveStreamRequest;
const DaiProxyApi = {
  StreamEvent: se,
  VODStreamRequest: vr,
  LiveStreamRequest: lr
};
class MoatTracker {
  constructor() {
    this.MOAT_PARTNER_CODE = "cbsiimajsint708425247896";
    this.adContextToVpaidEventMap = {
      ima: {
        start: "AdVideoStart",
        firstquartile: "AdVideoFirstQuartile",
        midpoint: "AdVideoMidpoint",
        thirdquartile: "AdVideoThirdQuartile",
        complete: "AdVideoComplete",
        pause: "AdPaused",
        resume: "AdPlaying",
        skip: "AdSkipped",
        volumechange: "AdVolumeChange",
        mute: "AdVolumeChange"
      },
      dai_sdk: {
        started: "AdVideoStart",
        firstquartile: "AdVideoFirstQuartile",
        midpoint: "AdVideoMidpoint",
        thirdquartile: "AdVideoThirdQuartile",
        complete: "AdVideoComplete",
        controlpause: "AdPaused",
        controlplay: "AdPlaying",
        controlvolumeset: "AdVolumeChange",
        controlmute: "AdVolumeChange",
        controlunmute: "AdVolumeChange"
      }
    };
  }
  destroy() {
    this.adContextToVpaidEventMap = null;
    this.trackingObj = null;
  }
  track(info) {
    const context = info.context, adData = info.adInfo;
    const ids = {
      level1: "",
      level2: "",
      level3: adData.wrapperAdId,
      level4: adData.wrapperCreativeId,
      slicer1: "vaw-can",
      slicer2: info.partner,
      slicer3: info.pageType,
      moatVASTSystem: context,
      moatVASTAdID: adData.wrapperAdId
    };
    info.viewGuid !== "" && (ids.zMoatVGUID = info.viewGuid);
    info.pageType !== "" && (ids.zMoatPT = info.pageType);
    this.initMoat(
      info.adVideoContainer,
      ids,
      adData.adDuration,
      this.MOAT_PARTNER_CODE,
      null
    );
  }
  untrack() {
    this.trackingObj = null;
  }
  trackEvent(data) {
    const vpEvt = this.adContextToVpaidEventMap[data.context][data.eventName.toLowerCase()];
    if (!vpEvt || !this.trackingObj) {
      return;
    }
    this.trackingObj.dispatchEvent({
      type: vpEvt,
      adVolume: data.volume
    });
  }
  /**
    * Code supplied by Moat, slightly massaged for typescript
    * c ad container
    * d ids (includes partner code, etc)
    * e duration of ad
    * k partner code
    * l url to the video asset used to display the ad
   */
  initMoat(c, d, e, k, l = null) {
    const g = document.createElement("script");
    let a = [];
    let f, h;
    const q = {
      adData: { ids: d, duration: e, url: l },
      dispatchEvent: function(b) {
        if (this.sendEvent) {
          if (a) {
            a.push(b);
            b = a;
            a = false;
          }
          this.sendEvent(b);
        } else {
          a.push(b);
        }
      }
    };
    const sfx = "_moatApi" + Math.floor(1e8 * Math.random());
    try {
      f = c.ownerDocument;
      h = f.defaultView || f.parentWindow;
    } catch (b) {
      h = window;
    }
    h[sfx] = q;
    g.type = "text/javascript";
    c && c.insertBefore(g, c.childNodes[0] || null);
    g.src = "https://z.moatads.com/" + k + "/moatvideo.js#" + sfx;
    this.trackingObj = q;
  }
}
class GamAdService {
  constructor(context) {
    this.context = context;
    this.trackingData = context.resource.ad.viewabilityTracking;
  }
  get adContainer() {
    var _a;
    return (_a = this.context.dom) == null ? void 0 : _a.adContainer;
  }
  get avia() {
    return this.context.avia;
  }
  set adSystem(v) {
    this.adSys = v;
  }
  get adSystem() {
    return this.adSys;
  }
  get omEnabled() {
    var _a;
    return !((_a = this.context.resource.ad.ssai) == null ? void 0 : _a.useApi) && this.context.playerOptions.enableOm;
  }
  get moatEnabled() {
    return this.context.playerOptions.enableMoat === true;
  }
  destroy() {
    var _a;
    (_a = this.moatTracker) == null ? void 0 : _a.destroy();
    this.moatTracker = null;
    this.trackingData = null;
    this.context = null;
  }
  // Moat tracking 
  trackAd(adInfo) {
    if (!this.moatEnabled) {
      return;
    }
    const td = this.trackingData;
    this.moatTracker.track({
      viewGuid: td.viewGuid,
      pageType: td.pageType,
      adInfo,
      adVideoContainer: this.adContainer,
      context: this.adSystem,
      partner: td.partner
    });
  }
  trackAdEvent(obj) {
    if (!this.moatEnabled) {
      return;
    }
    this.moatTracker.trackEvent(obj);
  }
  untrackAd() {
    if (!this.moatEnabled) {
      return;
    }
    this.moatTracker.untrack();
  }
  // End Moat-related API
  ///////////////////////
  getGamPlatformString() {
    return this.context.system.isDesktop ? "desktop" : this.context.system.isMobile ? "mobile_web" : "other";
  }
  getAdSystem() {
    return this.adSystem;
  }
  getAdBreakTypeFromPodIndex(idx) {
    return idx === 0 ? this.avia.AdBreakType.PRE : idx === -1 ? this.avia.AdBreakType.POST : this.avia.AdBreakType.MID;
  }
  // Ad Break (pod)
  assembleAdBreakInfo(ad, adTech) {
    var _a;
    const pi = ad.getAdPodInfo();
    const idx = pi.getPodIndex();
    return {
      adTechnology: adTech,
      adBreakDuration: pi.getMaxDuration(),
      adBreakPosition: idx,
      adTotal: pi.getTotalAds(),
      adBreakType: this.getAdBreakTypeFromPodIndex(idx),
      adServerName: this.adSystem,
      streamStartTime: (_a = pi.getTimeOffset) == null ? void 0 : _a.call(pi)
    };
  }
  assembleAdInfo(ad, adData) {
    const podInfo = ad.getAdPodInfo();
    const adPos = podInfo && podInfo.getAdPosition() || -1;
    const idInfo = this.getIdInfo(ad);
    const isIma = this.adSystem === AdSystem.IMA;
    const imaAd = ad;
    return {
      adObject: ad,
      adServerName: this.adSystem,
      adDuration: ad.getDuration(),
      adTitle: ad.getTitle(),
      adId: idInfo.adId,
      adPosition: adPos,
      adAssetUrl: isIma ? imaAd.getMediaUrl() : adData.mediaUrl || null,
      isVpaid: isIma ? this.getIsVpaid(imaAd) : null,
      wrapperAdId: idInfo.wrapperAdId,
      creativeId: idInfo.creativeId,
      wrapperCreativeId: idInfo.wrapperCreativeId,
      companionAds: isIma ? null : this.transformCompanionData(ad.getCompanionAds()),
      vastMediaHeight: isIma ? imaAd.getVastMediaHeight() : null,
      vastMediaWidth: isIma ? imaAd.getVastMediaWidth() : null,
      vastMediaBitrate: isIma ? imaAd.getVastMediaBitrate() : null
    };
  }
  createViewabilityTracker() {
    if (!this.moatEnabled) {
      return;
    }
    this.moatTracker = new MoatTracker();
  }
  // Google's SDK yields companion ads as objects with methods; the API
  // returns objects with properties (that don't necessarily correspond to SDK object methods).
  transformCompanionData(data) {
    if (!(data == null ? void 0 : data.length)) {
      return [];
    }
    const { Util } = this.avia;
    const sdkC = data;
    const apiC = data;
    const useCompanionAd = Util.isFunction(sdkC[0].getAdSlotId);
    const useCompanion = Util.isString(apiC[0].api_framework);
    if (useCompanionAd) {
      return sdkC.map((ca) => {
        return {
          apiFramework: ca.getContentType(),
          resource: ca.getContent(),
          height: ca.getHeight(),
          width: ca.getWidth(),
          adSlotId: ca.getAdSlotId()
        };
      });
    } else if (useCompanion) {
      return apiC.map((c) => {
        const { api_framework, resource, height, width, ad_slot_id, tracking_events } = c;
        return {
          apiFramework: api_framework,
          adSlotId: ad_slot_id,
          trackingEvents: tracking_events,
          resource,
          height,
          width
        };
      });
    }
    return [];
  }
  ////////////
  // PRIVATE
  ////////////
  getIdInfo(ad) {
    const w = this.getWrapperId(ad);
    const c = this.getCreativeId(ad);
    return {
      adId: w.adId,
      wrapperAdId: w.wrapperAdId,
      creativeId: c.creativeId,
      wrapperCreativeId: c.wrapperCreativeId,
      adServerName: AdSystem.IMA,
      adDuration: ad.getDuration()
    };
  }
  getWrapperId(ad) {
    const ids = ad.getWrapperAdIds();
    const len = Array.isArray(ids) && ids.length;
    const defId = ad.getAdId() || "";
    const adId = !len ? defId : ids[0];
    let wrapperAdId = !len ? defId : ids[ids.length - 1];
    if (!wrapperAdId) {
      wrapperAdId = null;
    }
    return {
      adId,
      wrapperAdId
    };
  }
  getCreativeId(ad) {
    const ids = ad.getWrapperCreativeIds();
    const len = Array.isArray(ids) && ids.length;
    const defId = ad.getCreativeId() || null;
    const creativeId = !len ? defId : ids[0];
    let wrapperCreativeId = !len ? defId : ids[ids.length - 1];
    if (!wrapperCreativeId) {
      wrapperCreativeId = null;
    }
    return {
      creativeId,
      wrapperCreativeId
    };
  }
  getIsVpaid(ad) {
    return ad.getContentType() === "application/javascript";
  }
}
class Ad {
  constructor(adResponse, podInfo) {
    this.data = adResponse;
    this.podInfo = podInfo;
  }
  getAdId() {
    return this.data.ad_id;
  }
  getAdPodInfo() {
    return this.podInfo;
  }
  getAdSystem() {
    return this.data.advertiser || null;
  }
  getAdvertiserName() {
    return this.data.advertiser || null;
  }
  getApiFramework() {
    return null;
  }
  getCreativeAdId() {
    return this.data.creative_ad_id;
  }
  getCreativeId() {
    return this.data.creative_id;
  }
  getDealId() {
    return this.data.deal_id || null;
  }
  getDescription() {
    return this.data.description;
  }
  getDuration() {
    return this.data.duration;
  }
  getTitle() {
    return this.data.title;
  }
  getSkipTimeOffset() {
    return 0;
  }
  isSkippable() {
    return false;
  }
  getDaiWrapperData() {
    let adId = null;
    let creativeId = null;
    let creativeAdId = null;
    if (this.data.wrappers && this.data.wrappers[0]) {
      const w0 = this.data.wrappers[0];
      adId = w0.ad_id;
      creativeId = w0.creative_id;
      creativeAdId = w0.creative_ad_id;
    }
    return { adId, creativeId, creativeAdId };
  }
  getWrapperAdIds() {
    return this.getWrapperPropArray("ad_id");
  }
  getWrapperCreativeIds() {
    return this.getWrapperPropArray("creative_id");
  }
  getWrapperCreativeAdIds() {
    return this.getWrapperPropArray("creative_ad_id");
  }
  getWrapperAdSystems() {
    return this.getWrapperPropArray("system");
  }
  getCompanionAds() {
    return this.data.companions || [];
  }
  getWrapperPropArray(propName) {
    const out = [], wrappers = this.data.wrappers || null;
    if (!wrappers) {
      return null;
    }
    let item, w;
    for (let i = 0, n = wrappers.length; i < n; i++) {
      w = wrappers[i];
      item = w[propName];
      item && item !== "" && out.push(item);
    }
    return out;
  }
}
class AdPodInfo {
  constructor(data, adPos, idx) {
    this.data = data;
    this.podIdx = idx;
    this.adPosition = adPos;
  }
  getAdPosition() {
    return this.adPosition;
  }
  setAdPosition(n) {
    this.adPosition = n;
  }
  getMaxDuration() {
    var _a;
    return (_a = this.data) == null ? void 0 : _a.duration;
  }
  getPodIndex() {
    return this.podIdx;
  }
  setPodIndex(n) {
    this.podIdx = n;
  }
  getTimeOffset() {
    return this.data.start;
  }
  getTotalAds() {
    if (typeof this.data.ads === "number") {
      return this.data.ads;
    }
    if (Array.isArray(this.data.ads)) {
      return this.data.ads.length;
    }
    return 0;
  }
}
const STREAM_URL_VOD = "https://dai.google.com/ondemand/v1/{FORMAT}/content/{CONTENT_SOURCE_ID}/vid/{VIDEO_ID}/stream";
const STREAM_URL_LIVE = "https://dai.google.com/linear/v1/{FORMAT}/event/{ASSET_KEY}/stream";
const _ApiStreamManager = class _ApiStreamManager {
  constructor(options) {
    var _a;
    this.eventStatusMap = {
      start: _ApiStreamManager.event.STARTED,
      firstquartile: _ApiStreamManager.event.FIRST_QUARTILE,
      midpoint: _ApiStreamManager.event.MIDPOINT,
      thirdquartile: _ApiStreamManager.event.THIRD_QUARTILE,
      complete: _ApiStreamManager.event.COMPLETE
    };
    this.adBreaks = [];
    this.currBreak = null;
    this.liveBreakInProgress = false;
    this.currBreakIndex = -1;
    this.currAd = null;
    this.currAdTzero = null;
    this.breakStatus = {};
    this.breakPoints = [];
    this.pollId = null;
    this.lastRecordedTime = -1;
    this.playedAds = [];
    this.liveMetadata = {};
    this.idCache = [];
    this.onTimeUpdate = (time) => {
      this.currentTime = time;
      if (!this.currAd) {
        return;
      }
    };
    this.aviaSdk = options == null ? void 0 : options.aviaSdk;
    this.emitter = new this.aviaSdk.Emitter();
    this.currEventStatus = this.createEventStatus();
    this.currBreakIndex = null;
    this.logger = options.logger;
    this.breakDetectionWindow = (_a = options.breakDetectionWindow) != null ? _a : 1.5;
  }
  ////////////////////////////////////////////////
  // "custom" Public API - support for promo skip
  skipAd() {
    const seekTime = (this.currAd.start || 0) + this.currAd.duration;
    this.resetUponAdComplete();
    return seekTime;
  }
  /////////////////////////////////////////
  // Public API - replicates API of DAI SDK
  addEventListener(name, fn) {
    this.emitter.on(name, fn);
  }
  removeEventListener(name, fn) {
    this.emitter.off(name, fn);
  }
  getHeaders() {
    const headers = {
      "Content-Type": "application/x-www-form-urlencoded"
    };
    const { isBrowser, userAgent } = this.aviaSdk.getSystemInfo();
    if (!isBrowser && userAgent) {
      headers["User-Agent"] = userAgent;
    }
    return headers;
  }
  setAdParameters(streamReq) {
    if (streamReq.apiKey) {
      streamReq.adTagParameters["api-key"] = streamReq.apiKey;
    }
    if (streamReq.authToken) {
      streamReq.adTagParameters["auth-token"] = streamReq.authToken;
    }
    if (streamReq.streamActivityMonitorId) {
      streamReq.adTagParameters["dai-sam-id"] = streamReq.streamActivityMonitorId;
    }
  }
  requestStream(streamReq, errorRecovery = null) {
    this.setAdParameters(streamReq);
    if (streamReq.assetKey) {
      this.isLive = true;
      this.requestLiveStream(streamReq, errorRecovery);
      return;
    }
    this.aviaSdk.Util.request({
      method: this.aviaSdk.RequestMethod.POST,
      errorRecovery,
      headers: this.getHeaders(),
      url: this.getUrl(streamReq),
      data: streamReq.adTagParameters,
      responseType: this.aviaSdk.ResponseType.JSON
    }).then((response) => {
      this.gatherStreamInfo(response);
      this.emitCues();
      this.beginPoll();
      this.emitLoaded(response);
    }).catch((error) => {
      const msg = `Error. Status: ${error.status || "Unknown"}; Message: ${error.message}`;
      this.logger.error(msg);
      this.emitError(msg, this.aviaSdk.ErrorCode.DAI_NETWORK_ERROR);
    });
  }
  requestLiveStream(streamReq, errorRecovery = null) {
    this.aviaSdk.request({
      method: this.aviaSdk.RequestMethod.POST,
      errorRecovery,
      headers: this.getHeaders(),
      url: this.getUrl(streamReq),
      data: streamReq.adTagParameters
    }).then((response) => {
      if (!response.stream_manifest) {
        this.emitError("DAI API: Stream manifest not found in response", this.aviaSdk.ErrorCode.DAI_DATA_ERROR);
      } else {
        this.mediaVerificationUrl = response.media_verification_url;
        this.streamId = response.stream_id;
        this.emitLoaded(response);
        if (!response.metadata_url) {
          this.aviaSdk.Logger.warn("DAI API StreamManager: metadata_url not found in API response");
        } else {
          const pollFreqMs = response.polling_frequency * 1e3;
          const poll = () => {
            clearTimeout(this.liveMetadataPollTimeout);
            this.aviaSdk.request({
              url: response.metadata_url,
              responseType: this.aviaSdk.ResponseType.JSON
            }).then((res) => {
              if (!this.aviaSdk.Util.isEmpty(res.tags)) {
                this.liveMetadata = {
                  tags: __spreadValues(__spreadValues({}, this.liveMetadata.tags), res.tags),
                  ads: __spreadValues(__spreadValues({}, this.liveMetadata.ads), res.ads),
                  ad_breaks: __spreadValues(__spreadValues({}, this.liveMetadata.ad_breaks), res.ad_breaks)
                };
              }
            }).catch((error) => {
              this.aviaSdk.Logger.warn(`DAI API StreamManager: polling error: ${error}`);
            }).then(() => {
              this.liveMetadataPollTimeout = setTimeout(poll, pollFreqMs);
            });
          };
          poll();
        }
      }
    }).catch((error) => {
      this.emitError("DAI API live stream request error", this.aviaSdk.ErrorCode.DAI_NETWORK_ERROR);
    });
  }
  setClickElement(clickElement) {
    if (!clickElement) {
      return;
    }
    this.clickEl = clickElement || null;
    this.clickThruHandler = () => {
      this.hClickThru();
    };
    this.clickEl.addEventListener("click", this.clickThruHandler);
  }
  // supply streamTime in seconds; returns content time
  contentTimeForStreamTime(streamTime) {
    const bks = this.adBreaks;
    let breakSum = 0, b;
    if (streamTime === void 0) {
      streamTime = this.streamDur;
    }
    for (let i = 0, n = bks.length; i < n; i++) {
      b = bks[i];
      if (streamTime > b.start) {
        if (streamTime >= b.end) {
          breakSum += b.duration;
          if (i === n - 1) {
            return streamTime - breakSum;
          }
        } else {
          return b.start - breakSum;
        }
      } else {
        return streamTime - breakSum;
      }
    }
    return streamTime;
  }
  streamTimeForContentTime(t) {
    const bks = this.adBreaks;
    let sum = 0, bct, b;
    for (let i = 0, n = bks.length; i < n; i++) {
      b = bks[i];
      bct = this.contentTimeForStreamTime(bks[i].start);
      if (t >= bct) {
        sum += b.duration;
      } else {
        break;
      }
    }
    return t + sum;
  }
  previousCuePointForStreamTime(streamTime) {
    const bks = this.adBreaks;
    let i = bks.length, b;
    while (i--) {
      b = bks[i];
      if (streamTime >= b.start) {
        return !b.played ? this.cuePointFromBreak(b) : null;
      }
    }
    return null;
  }
  // Pass  processed metadata - used for media_verification call
  onTimedMetadata(metadata) {
    if (this.isLive) {
      this.processLiveMetadata(metadata);
    } else {
      const id = metadata.TXXX;
      if (!this.idCache.includes(id)) {
        this.idCache.push(id);
        this.aviaSdk.request({
          url: this.mediaVerificationUrl + id,
          responseType: this.aviaSdk.ResponseType.JSON
        }).catch((e) => {
          this.logger.warn(`Dropped verification request for ${id || "null"}`);
        });
      }
    }
  }
  processMetadata() {
  }
  // Resets the stream manager and removes any continuous polling.
  reset() {
    clearTimeout(this.liveMetadataPollTimeout);
    clearInterval(this.pollId);
    this.clickEl && this.clickEl.removeEventListener("click", this.clickThruHandler);
    this.clickEl = null;
    this.streamId = null;
    this.adBreaks = [];
    this.breakPoints = [];
    this.streamDur = NaN;
    this.currBreak = null;
    this.currBreakIndex = null;
    this.liveBreakInProgress = false;
    this.currAd = null;
    this.mediaVerificationUrl = null;
    this.resetUponAdComplete();
    this.lastRecordedTime = -1;
    this.pollId = null;
    this.liveMetadata = null;
  }
  replaceAdTagParameters(adTagParameters) {
  }
  // END Public API
  ////////////////////////////
  ///////////
  // PRIVATE
  processLiveMetadata(metadata) {
    var _a, _b, _c;
    const id = metadata.TXXX;
    const cache = this.liveMetadata;
    const found = cache && ((_a = Object.keys(cache.tags || {})) == null ? void 0 : _a.find((k) => id.includes(k)));
    if (!found) {
      this.logger.warn(`ID ${id} not found in metadata.tags`);
      return;
    }
    const tag = cache.tags[found];
    const type = tag.type;
    const brkId = tag.ad_break_id;
    const total = cache.ad_breaks[brkId].ads;
    const ad = cache.ads[tag.ad];
    const map = {
      firstquartile: "first",
      midpoint: "mid",
      thirdquartile: "third",
      start: "start",
      complete: "complete"
    };
    if (this.hasPlayed(ad.ad_id)) {
      if (type === "complete") {
        if (total && (ad == null ? void 0 : ad.position) === total) {
          this.resetUponAdComplete();
          this.endBreak();
        }
      }
      return;
    }
    const stat = this.currEventStatus;
    const verify = (id2, type2) => {
      stat[map[type2]] = true;
      this.aviaSdk.request({
        url: this.mediaVerificationUrl + id2,
        responseType: this.aviaSdk.ResponseType.JSON
      }).catch((e) => {
        if (e.message !== "Unable to parse response.") {
          this.logger.warn(`DAI media verification error: ${e.message}`);
        }
      });
    };
    if (type === "start" && !stat[map[type]]) {
      if (!this.liveBreakInProgress) {
        const brk = cache.ad_breaks[brkId];
        const breakObj = {
          adsTotal: total,
          type: brk.type,
          duration: brk.duration
        };
        this.currBreakIndex = this.getBreakIndex(brk);
        this.beginBreak(breakObj);
      }
      this.beginAd(ad, ad.ad_id);
      verify(id, type);
    } else if (type === "complete" && !stat[map[type]]) {
      if ((_b = this.currAd) == null ? void 0 : _b.duration) {
        this.emitProgress(null);
      }
      if (this.currAd) {
        this.markAsPlayed(ad.ad_id);
        this.emitAdComplete();
        verify(id, type);
      }
      this.resetUponAdComplete();
      if (ad.position === total) {
        this.endBreak();
      }
    } else if (this.currAd && (type.includes("mid") || type.includes("quartile")) && this.eventStatusMap[type] && !stat[map[type]]) {
      this.emit(this.eventStatusMap[type], this.createStreamData({}));
      verify(id, type);
    } else if (type === "progress" && (ad == null ? void 0 : ad.ad_id) && !this.hasPlayed(ad == null ? void 0 : ad.ad_id)) {
      const p = ((_c = this.currAd) == null ? void 0 : _c.duration) ? (Date.now() - this.currAdTzero) * 1e-3 : 0;
      this.emitProgress(p);
    }
  }
  markAsPlayed(id) {
    this.playedAds.push(id);
  }
  hasPlayed(id) {
    return id && this.playedAds.indexOf(id) >= 0;
  }
  // State
  beginPoll() {
    clearInterval(this.pollId);
    this.pollId = setInterval(() => {
      this.checkState();
    }, 100);
  }
  checkState() {
    const t = this.currentTime;
    if (!isNaN(t) && t > 0 && t > this.lastRecordedTime) {
      if (!this.currBreak) {
        const info = this.getBreakForStreamTime(t);
        const k = info.break;
        if (k && k.played) {
          this.emitAdPeriodStarted(k);
        } else if (k) {
          this.currBreak = k;
          this.beginBreak(k);
        }
      }
      if (this.currBreak) {
        const ck = this.currBreak;
        if (t >= ck.end) {
          this.monitorAdStatus(t, ck);
          this.endBreak();
        } else {
          this.monitorAdStatus(t, ck);
        }
      }
    }
    !isNaN(t) && t >= 0 && (this.lastRecordedTime = t);
  }
  monitorAdStatus(t, brk) {
    const ads = brk.ads, brkSt = brk.start;
    if (this.currAd) {
      this.monitorCurrentAd(t);
      return;
    }
    let adSt, i = ads.length;
    while (i--) {
      adSt = ads[i].start || 0;
      if (t >= adSt || adSt === void 0) {
        if (!this.breakStatus[`t_${brkSt}`][`t_${adSt}`]) {
          this.currBreakIndex = this.getBreakIndex(brk);
          this.beginAd(ads[i], adSt);
          break;
        }
      }
    }
  }
  getBreakIndex(brk) {
    const { type, index } = brk;
    const typ = type.toLowerCase();
    return typ === "pre" ? 0 : typ === "mid" ? index || this.currBreakIndex++ : -1;
  }
  //  inspect curr Ad 'events' array for ad life-cycle events
  monitorCurrentAd(t) {
    const evts = this.currAd.events;
    const status = this.currEventStatus;
    let emitProg = true, i = evts.length, evt;
    while (i--) {
      evt = evts[i];
      if (t >= evt.time && !status[evt.type]) {
        status[evt.type] = true;
        if (evt.type === "complete" || t >= this.currAd.start + this.currAd.duration) {
          emitProg = false;
          this.emitAdComplete();
          this.resetUponAdComplete();
          break;
        } else if (evt.type !== "start") {
          emitProg = false;
          this.emit(this.eventStatusMap[evt.type], this.createStreamData({}));
          break;
        }
      }
    }
    emitProg && this.emitProgress(t);
  }
  resetUponAdComplete() {
    this.currEventStatus = this.createEventStatus();
    this.currAd = null;
    this.currAdTzero = null;
  }
  ///////////////////////////////
  // adBreak/ad life-cycle points
  beginBreak(brk) {
    this.currBreak = brk;
    this.currBreak.played = true;
    this.liveBreakInProgress = this.isLive;
    if (!this.isLive) {
      this.emitCues();
    }
    this.emit(_ApiStreamManager.event.AD_BREAK_STARTED, this.createStreamData({}));
  }
  endBreak() {
    this.emit(_ApiStreamManager.event.AD_BREAK_ENDED, this.createStreamData({}));
    this.currBreak = null;
  }
  beginAd(ad, adSt) {
    var _a, _b, _c;
    this.currAd = ad;
    this.currBreak = !this.isLive ? this.currBreak : (_b = (_a = this.liveMetadata) == null ? void 0 : _a.ad_breaks) == null ? void 0 : _b[ad.ad_break_id];
    this.currAdTzero = Date.now();
    if (!this.isLive) {
      this.breakStatus[`t_${(_c = this.currBreak) == null ? void 0 : _c.start}`][`t_${adSt}`] = true;
      this.currEventStatus.start = true;
    }
    const { seq, position } = this.currAd;
    const pos = seq === 0 || position === 0 ? 0 : seq || position;
    const podInfo = new AdPodInfo(this.currBreak, pos, this.currBreakIndex);
    const adInfo = new Ad(this.currAd, podInfo);
    const e = new StreamEvent(_ApiStreamManager.event.STARTED, this, this.createStreamData({}), adInfo);
    this.emitter.dispatchEvt(e);
  }
  /////////////////
  // Event handling
  hClickThru() {
    if (!this.currAd) {
      return;
    }
    const u = this.currAd.clickthrough_url;
    u && u !== "" && window.open(u);
    this.emit(_ApiStreamManager.event.CLICK);
  }
  /////////////////
  // Event dispatch
  emit(name, data = null) {
    const e = new StreamEvent(name, this, data);
    this.emitter.dispatchEvt(e);
  }
  emitCues() {
    if (this.isLive) {
      return;
    }
    this.emit(_ApiStreamManager.event.CUEPOINTS_CHANGED, this.createStreamData({
      cuepoints: this.assembleCuePoints()
    }));
  }
  // note: passing null will force progress to 100%
  emitProgress(t, duration) {
    var _a;
    const ap = this.createAdProgressData(t, duration || ((_a = this.currAd) == null ? void 0 : _a.duration));
    this.emit(_ApiStreamManager.event.AD_PROGRESS, this.createStreamData({
      adProgressData: ap
    }));
  }
  emitLoaded(s) {
    this.emit(_ApiStreamManager.event.LOADED, this.createStreamData({
      subtitles: s.subtitles,
      manifestFormat: this.getFormat(s.stream_manifest),
      url: s.stream_manifest,
      streamId: s.stream_id
    }));
  }
  emitAdComplete() {
    if (!this.isLive) {
      this.emitProgress(null);
    }
    this.emit(_ApiStreamManager.event.COMPLETE, this.createStreamData({}));
  }
  emitError(msg, code) {
    const d = this.createStreamData({
      errorMessage: msg,
      code
    });
    this.emit(_ApiStreamManager.event.ERROR, d);
  }
  emitAdPeriodStarted(k) {
    this.emitter.emit(_ApiStreamManager.event.AD_PERIOD_STARTED, this.createStreamData({
      streamResumeTime: k ? k.start + k.duration + 0.1 : null
    }));
  }
  ///////
  // util
  createAdProgressData(t, duration = null) {
    var _a, _b, _c, _d, _e;
    return {
      adBreakDuration: ((_a = this.currBreak) == null ? void 0 : _a.duration) || null,
      adPeriodDuration: null,
      adPosition: ((_b = this.currAd) == null ? void 0 : _b.seq) || null,
      currentTime: !t ? duration || 0 : this.aviaSdk.Util.clampValue(t - (((_c = this.currAd) == null ? void 0 : _c.start) || 0), 0, duration || 0),
      duration: duration || -1,
      totalAds: ((_e = (_d = this.currBreak) == null ? void 0 : _d.ads) == null ? void 0 : _e.length) || null
    };
  }
  createEventStatus() {
    return {
      start: false,
      first: false,
      mid: false,
      third: false,
      complete: false
    };
  }
  assembleCuePoints() {
    const cpa = [];
    for (let i = 0, n = this.adBreaks.length; i < n; i++) {
      cpa.push(this.cuePointFromBreak(this.adBreaks[i]));
    }
    return cpa;
  }
  getBreakForStreamTime(t) {
    let b;
    for (let i = 0, n = this.adBreaks.length; i < n; i++) {
      b = this.adBreaks[i];
      const timeSinceStart = t - b.start;
      if (t >= b.start && t < b.end && timeSinceStart <= this.breakDetectionWindow) {
        if (!this.currBreak) {
          return { break: b, index: i };
        }
      }
    }
    return { break: null, index: null };
  }
  getUrl(streamReq) {
    const isLive = !!streamReq.assetKey;
    const url = isLive ? STREAM_URL_LIVE : STREAM_URL_VOD;
    if (isLive) {
      return url.replace("{FORMAT}", streamReq.format || "hls").replace("{ASSET_KEY}", streamReq.assetKey);
    }
    return url.replace("{FORMAT}", streamReq.format).replace("{CONTENT_SOURCE_ID}", streamReq.contentSourceId).replace("{VIDEO_ID}", streamReq.videoId);
  }
  cuePointFromBreak(b) {
    return {
      start: b.start,
      end: b.end,
      played: b.played
    };
  }
  createStreamData(d) {
    return {
      adProgressData: (d == null ? void 0 : d.adProgressData) || null,
      cuepoints: (d == null ? void 0 : d.cuepoints) || null,
      errorMessage: (d == null ? void 0 : d.errorMessage) || null,
      streamId: this.streamId || null,
      manifestFormat: (d == null ? void 0 : d.manifestFormat) || null,
      subtitles: (d == null ? void 0 : d.subtitles) || null,
      url: (d == null ? void 0 : d.url) || null,
      streamResumeTime: (d == null ? void 0 : d.streamResumeTime) || null,
      code: (d == null ? void 0 : d.code) || null
    };
  }
  getFormat(u) {
    if (u.indexOf(".m3u8") >= 0) {
      return this.aviaSdk.VideoFormat.HLS;
    }
    if (u.indexOf(".mpd") >= 0) {
      return this.aviaSdk.VideoFormat.DASH;
    }
    return this.aviaSdk.VideoFormat.UNKNOWN;
  }
  gatherBreakInfo(b) {
    const nBreaks = b && b.length || 0;
    let k, s, e, d;
    let midSeq = 1;
    for (let i = 0; i < nBreaks; i++) {
      k = b[i];
      s = k.start;
      d = k.duration;
      e = s + d;
      this.breakPoints.push(s);
      const o = {
        duration: d,
        start: s,
        end: e,
        played: false,
        type: k.type,
        ads: k.ads,
        index: i,
        seq: k.type === "mid" ? midSeq++ : 0
      };
      this.adBreaks.push(o);
      if (!this.isLive && Array.isArray(k.ads)) {
        const adStat = this.breakStatus["t_" + s] = {};
        let ast;
        for (let q = 0, w = k.ads.length; q < w; q++) {
          ast = k.ads[q].start || 0;
          adStat["t_" + ast] = false;
        }
      }
    }
  }
  gatherStreamInfo(s) {
    this.streamDur = s.total_duration;
    this.mediaVerificationUrl = s.media_verification_url;
    this.streamId = s.stream_id;
    this.gatherBreakInfo(s.ad_breaks);
  }
};
_ApiStreamManager.event = {
  LOADED: "loaded",
  STREAM_INITIALIZED: "streamInitialized",
  CUEPOINTS_CHANGED: "cuePointsChanged",
  AD_BREAK_STARTED: "adBreakStarted",
  AD_BREAK_ENDED: "adBreakEnded",
  STARTED: "started",
  COMPLETE: "complete",
  AD_PROGRESS: "adProgress",
  FIRST_QUARTILE: "firstQuartile",
  MIDPOINT: "midpoint",
  THIRD_QUARTILE: "thirdQuartile",
  CLICK: "click",
  ERROR: "error",
  SKIPPED: "skipped",
  SKIPPABLE_STATE_CHANGED: "skippablestatechanged",
  AD_PERIOD_STARTED: "adPeriodStarted",
  AD_PERIOD_ENDED: "adPeriodEnded",
  SHOW_AD_UI: "showadui",
  HIDE_AD_UI: "hideadui"
};
let ApiStreamManager = _ApiStreamManager;
const gamLocaleCodes = [
  "ar",
  "ar_eg",
  "ar_sa",
  "bg",
  "ca",
  "zh",
  "zh_cn",
  "zh_hk",
  "zh_tw",
  "hr",
  "cs",
  "da",
  "nl",
  "en",
  "en_au",
  "en_ca",
  "en_gb",
  "en_ie",
  "en_in",
  "en_sg",
  "en_za",
  "et",
  "fil",
  "fi",
  "fr",
  "fr_ca",
  "fr_ch",
  "de",
  "de_at",
  "el",
  "he",
  "hi",
  "hu",
  "is",
  "id",
  "it",
  "ja",
  "ko",
  "lv",
  "lt",
  "ms",
  "no",
  "pl",
  "pt",
  "pt_br",
  "pt_pt",
  "ro",
  "ru",
  "sr",
  "sk",
  "sl",
  "es",
  "es_419",
  "es_ar",
  "es_cl",
  "es_co",
  "es_cr",
  "es_do",
  "es_ec",
  "es_sv",
  "es_gt",
  "es_hn",
  "es_mx",
  "es_ni",
  "es_pa",
  "es_pe",
  "es_pr",
  "es_py",
  "es_us",
  "es_uy",
  "es_ve",
  "sv",
  "th",
  "tr",
  "uk",
  "vi"
];
class DaiAdService extends GamAdService {
  constructor(context, sdk, videoInterface) {
    super(context);
    this.pSdk = null;
    this.usesApi = false;
    this.videoIface = null;
    this.hVideoAddOrRemove = (e) => {
      var _a;
      (_a = this.streamMgr) == null ? void 0 : _a.reset();
      this.streamMgr = null;
      if (e.type === this.avia.PlayerEvent.VIDEO_ELEMENT_ADDED) {
        if (this.usesApi) {
          this.videoIface = this.avia.Util.createSimpleVideoInterface();
        } else {
          this.videoIface = e.detail.video;
        }
      } else {
        this.videoIface = null;
      }
    };
    this.pSdk = sdk;
    this.videoIface = videoInterface;
    this.usesApi = context.resource.ad.ssai.useApi === true;
    this.adSystem = this.usesApi ? AdSystem.DAI_API : AdSystem.DAI_SDK;
    this.listenToVideoChanges(true);
    this.initViewabilityTracking();
  }
  destroy() {
    this.listenToVideoChanges(false);
    this.streamMgr && this.streamMgr.reset();
    this.streamMgr = null;
    this.pSdk = null;
    this.videoIface = null;
    super.destroy();
  }
  initViewabilityTracking() {
    this.createViewabilityTracker();
  }
  get videoInterface() {
    return this.videoIface;
  }
  get usesDaiApi() {
    return this.usesApi;
  }
  get sdk() {
    return this.pSdk;
  }
  setDuration(d) {
    if (this.usesApi) {
      this.videoIface.duration = d;
    }
  }
  setCurrentTime(t) {
    this.usesApi && (this.videoIface.currentTime = t);
  }
  reset() {
    this.streamMgr.reset();
    if (this.usesApi) {
      this.videoIface.duration = NaN;
      this.videoIface.currentTime = NaN;
    }
  }
  assembleAdInfo(ad, adData) {
    if (this.adSystem === AdSystem.DAI_SDK) {
      return super.assembleAdInfo(ad, adData);
    }
    const podInfo = ad.getAdPodInfo();
    const adPos = podInfo && podInfo.getAdPosition() || -1;
    const { adId: wrapperAdId, creativeId: wrapperCreativeId } = ad.getDaiWrapperData();
    const adId = wrapperAdId != null ? wrapperAdId : ad.getAdId();
    const creativeId = wrapperCreativeId != null ? wrapperCreativeId : ad.getCreativeId();
    return {
      adObject: ad,
      adServerName: this.adSystem,
      adDuration: ad.getDuration(),
      adTitle: ad.getTitle(),
      adId,
      adPosition: adPos,
      adAssetUrl: adData.mediaUrl || null,
      isVpaid: false,
      wrapperAdId: adId,
      creativeId,
      companionAds: this.transformCompanionData(ad.getCompanionAds()),
      wrapperCreativeId: creativeId,
      vastMediaHeight: null,
      vastMediaWidth: null,
      vastMediaBitrate: null
    };
  }
  getStreamManager(breakDetectionWindow) {
    if (!this.streamMgr && this.sdk) {
      if (this.usesApi) {
        this.streamMgr = new ApiStreamManager({
          logger: this.context.logger,
          aviaSdk: this.avia,
          breakDetectionWindow
        });
      } else if (this.videoIface) {
        let localeCode;
        let uiSettings;
        const { localization } = this.context;
        const sysLang = localization.language;
        const { compareLanguageTags } = this.avia.Util;
        for (let i = 0, n = gamLocaleCodes.length; i < n; i++) {
          const c = gamLocaleCodes[i];
          if (compareLanguageTags(c, sysLang)) {
            localeCode = c;
            break;
          }
        }
        if (localeCode) {
          uiSettings = new this.sdk.UiSettings();
          uiSettings.setLocale(localeCode);
        }
        this.streamMgr = new this.sdk.StreamManager(this.videoIface, this.adContainer, uiSettings);
      }
    }
    return this.streamMgr;
  }
  listenToVideoChanges(flag) {
    const p = this.context.player;
    const verb = flag ? "on" : "off";
    p == null ? void 0 : p[verb](this.avia.PlayerEvent.VIDEO_ELEMENT_ADDED, this.hVideoAddOrRemove);
    p == null ? void 0 : p[verb](this.avia.PlayerEvent.VIDEO_ELEMENT_REMOVED, this.hVideoAddOrRemove);
  }
}
const _ImaAdsLoader = class _ImaAdsLoader {
  constructor(options) {
    this.eMap = {
      errorHandler: null,
      adsMgrLoadedHandler: null
    };
    this.omEnabled = true;
    this.initialized = false;
    this.callbacks = {
      error: null,
      mgrLoaded: null
    };
    this.opts = options;
    this.adService = this.opts.adService;
    this.sdk = this.adService.sdk;
    this.omEnabled = options.enableOm;
    this.eMap.errorHandler = (e) => this.hError(e);
    this.eMap.adsMgrLoadedHandler = (e) => this.hAdsMgrLoaded(e);
  }
  destroy() {
    if (this.adsLoader) {
      this.adsLoader.removeEventListener(
        this.sdk.AdErrorEvent.Type.AD_ERROR,
        this.eMap.errorHandler
      );
      this.adsLoader.removeEventListener(
        this.sdk.AdsManagerLoadedEvent.Type.ADS_MANAGER_LOADED,
        this.eMap.adsMgrLoadedHandler
      );
      this.adsLoader.destroy();
    }
    this.adsLoader = null;
    this.adService = null;
    this.sdk = null;
  }
  /**
    * Initialize may only be called if playback is permitted, i.e,
    * if autoplay is enabled or a valid user gesture has occurred.
    * Returns false if the SDK has become undefined.
    */
  initialize() {
    const o = this.opts;
    const sdk = this.sdk;
    if (!sdk || !sdk.AdsLoader) {
      return false;
    }
    if (this.initialized) {
      return true;
    }
    const adc = new sdk.AdDisplayContainer(
      o.adContainer,
      o.video,
      o.adClickEl
    );
    adc.initialize();
    this.adsLoader = new sdk.AdsLoader(adc);
    const imaSettings = this.adsLoader.getSettings();
    this.populateSdkSettings(imaSettings);
    this.adsLoader.addEventListener(
      sdk.AdsManagerLoadedEvent.Type.ADS_MANAGER_LOADED,
      this.eMap.adsMgrLoadedHandler
    );
    this.adsLoader.addEventListener(sdk.AdErrorEvent.Type.AD_ERROR, this.eMap.errorHandler);
    this.initialized = true;
    return true;
  }
  getSdkVersion() {
    var _a;
    return (_a = this.adsLoader) == null ? void 0 : _a.getVersion();
  }
  set onAdsManagerLoaded(h) {
    this.callbacks.mgrLoaded = h;
  }
  set onAdsLoaderError(h) {
    this.callbacks.error = h;
  }
  requestAds(adsRequest) {
    if (this.omEnabled) {
      enableOmFullAccess(adsRequest, this.sdk);
    }
    this.adsLoader && this.adsLoader.requestAds(adsRequest);
  }
  contentComplete() {
    this.adsLoader && this.adsLoader.contentComplete();
  }
  getSettings() {
    return this.adsLoader ? this.adsLoader.getSettings() : null;
  }
  hAdsMgrLoaded(e) {
    this.callbacks.mgrLoaded(e);
  }
  hError(e) {
    const adErrorInfo = this.parseAdErrorEvent(e);
    this.callbacks.error(adErrorInfo);
  }
  parseAdErrorEvent(e) {
    return this.adService.parseAdError(e);
  }
  populateSdkSettings(settings) {
    const sdkSettings = this.opts.sdkSettings;
    settings.setVpaidMode(sdkSettings.vpaidMode);
    settings.setDisableCustomPlaybackForIOS10Plus(sdkSettings.disableCustomPlaybackForIOS10Plus);
    settings.setPlayerType(sdkSettings.playerType);
    settings.setPlayerVersion(sdkSettings.playerVersion);
  }
};
_ImaAdsLoader.event = {
  ADS_MANAGER_LOADED: "adsManagerLoaded",
  ADS_LOADER_ERROR: "adsLoaderError"
};
let ImaAdsLoader = _ImaAdsLoader;
class ImaAdService extends GamAdService {
  constructor(context, vpaidMode, enableOm) {
    super(context);
    this.adsLoaderInitialized = false;
    this.useOm = false;
    this.hVideoAddOrRemove = (event) => {
      if (event.type === this.avia.PlayerEvent.VIDEO_ELEMENT_ADDED) {
        if (this.adsLoaderInitialized) {
          this.killAdsLoader();
        }
        this.createAdsLoader(this.useOm && this.omEnabled, event.detail);
      }
    };
    this.vpaidMode = vpaidMode || this.sdk.ImaSdkSettings.VpaidMode.INSECURE;
    this.adSystem = AdSystem.IMA;
    this.useOm = enableOm;
    this.listenToVideoChanges(true);
    this.createAdsLoader(this.useOm && this.omEnabled);
  }
  destroy() {
    this.killAdsLoader();
    super.destroy();
  }
  get sdk() {
    var _a;
    const global = this.context.system.global;
    return (_a = global.google) == null ? void 0 : _a.ima;
  }
  getSdkVersion() {
    var _a;
    return (_a = this.pAdsLoader) == null ? void 0 : _a.getSdkVersion();
  }
  get sdkSettings() {
    const bi = this.context.buildInfo;
    return {
      vpaidMode: this.vpaidMode,
      disableCustomPlaybackForIOS10Plus: false,
      playerType: bi.playerName,
      playerVersion: bi.playerVersion
    };
  }
  get defaultRenderingSettings() {
    return {
      bitrate: 900,
      enablePreloading: false,
      loadVideoTimeout: -1,
      // ms, default 8000 ms
      playAdsAfterTime: void 0,
      restoreCustomPlaybackStateOnAdBreakComplete: false
    };
  }
  get adsLoader() {
    return this.pAdsLoader;
  }
  createAdsLoader(enableOm, videoEl) {
    if (this.pAdsLoader) {
      return;
    }
    const { adClickEl, video, adContainer } = this.context.dom;
    const vidEl = videoEl || video;
    this.pAdsLoader = new ImaAdsLoader({
      enableOm,
      adContainer,
      adClickEl,
      video: vidEl,
      sdkSettings: this.sdkSettings,
      adService: this
    });
  }
  initializeAdsLoader() {
    if (this.adsLoaderInitialized) {
      return true;
    }
    this.adsLoaderInitialized = true;
    this.createViewabilityTracker();
    return this.pAdsLoader.initialize();
  }
  // Error
  parseAdError(e) {
    const err = e.getError(), reqCtx = e.getUserRequestContext(), inner = err.getInnerError();
    return {
      type: this.getAdErrorType(err),
      errorCode: err.getErrorCode(),
      vastErrorCode: err.getVastErrorCode(),
      message: err.getMessage(),
      innerErrorMessage: this.context.avia.Util.isString(inner) ? inner : null,
      sdkVersion: this.sdk.VERSION,
      requestContext: reqCtx || null
    };
  }
  //////////
  // PRIVATE
  killAdsLoader() {
    var _a, _b;
    (_a = this.pAdsLoader) == null ? void 0 : _a.contentComplete();
    (_b = this.pAdsLoader) == null ? void 0 : _b.destroy();
    this.adsLoaderInitialized = false;
    this.pAdsLoader = null;
  }
  getAdErrorType(err) {
    const t = err.getType();
    return t === this.sdk.AdError.Type.AD_LOAD ? "adLoad" : "adPlay";
  }
  listenToVideoChanges(flag) {
    const p = this.context.player;
    const verb = flag ? "on" : "off";
    p == null ? void 0 : p[verb](this.avia.PlayerEvent.VIDEO_ELEMENT_ADDED, this.hVideoAddOrRemove);
    p == null ? void 0 : p[verb](this.avia.PlayerEvent.VIDEO_ELEMENT_REMOVED, this.hVideoAddOrRemove);
  }
}
function isValidSsaiConfig(ssaiCfg) {
  return !!((ssaiCfg == null ? void 0 : ssaiCfg.assetKey) || (ssaiCfg == null ? void 0 : ssaiCfg.videoId) && ssaiCfg.contentSourceId);
}
function isValidCsaiConfig(csaiCfg) {
  return !!(csaiCfg == null ? void 0 : csaiCfg.adCallUrl) || !!(csaiCfg == null ? void 0 : csaiCfg.adsResponse);
}
const GAM = "gam";
var ClickThroughNavigation = /* @__PURE__ */ ((ClickThroughNavigation2) => {
  ClickThroughNavigation2["EXTERNAL"] = "external";
  ClickThroughNavigation2["NOT_SUPPORTED"] = "notSupported";
  return ClickThroughNavigation2;
})(ClickThroughNavigation || {});
function gam(options = {}) {
  return {
    id: GAM,
    factory: createGamPlugin,
    options
  };
}
const GamMeasurement = {
  DAI_STREAM_METADATA_LOAD: "dai-stream-metadata-load"
};
const PLAYER_ACTIVE = "unmutedActive";
const PLAYER_INACTIVE = "mutedInactive";
function createGamPlugin(services, options) {
  return __async(this, null, function* () {
    const { player, avia } = services;
    let csaiAdService;
    let ssaiAdService;
    let adapter;
    player.registerAdapter({
      id: GAM,
      role: [avia.AdapterRole.AD],
      options,
      factory: function createGamAdapter(context, options2) {
        return __async(this, null, function* () {
          var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r;
          const { avia: avia2, system, resource, dom, playerOptions, logger } = context;
          const ad = resource.ad;
          const useCsai = isValidCsaiConfig(ad.csai);
          const useSsai = isValidSsaiConfig(ad.ssai);
          const enableOm = playerOptions.enableOm === true;
          const enableMoat = playerOptions.enableMoat === true;
          const debugSuffix = options2.debug === true ? "_debug" : "";
          const useApi = ((_a = ad.ssai) == null ? void 0 : _a.useApi) === true;
          const enableCustomUi = ((_c = (_b = ad.ssai) == null ? void 0 : _b.customUiOptions) == null ? void 0 : _c.enabled) === true;
          if (useSsai) {
            let daiSdk = (_f = (_e = (_d = system.global.google) == null ? void 0 : _d.ima) == null ? void 0 : _e.dai) == null ? void 0 : _f.api;
            if (!daiSdk && !useApi) {
              const url = ((_g = options2.dependencies) == null ? void 0 : _g.dai) || `//imasdk.googleapis.com/js/sdkloader/ima3_dai${debugSuffix}.js`;
              yield avia2.Util.loadScript(
                { url },
                playerOptions,
                () => {
                  var _a2, _b2, _c2;
                  return (_c2 = (_b2 = (_a2 = system.global.google) == null ? void 0 : _a2.ima) == null ? void 0 : _b2.dai) == null ? void 0 : _c2.api;
                }
              );
              daiSdk = (_j = (_i = (_h = system.global.google) == null ? void 0 : _h.ima) == null ? void 0 : _i.dai) == null ? void 0 : _j.api;
            }
            if (!daiSdk && !useApi) {
              throw new Error("GAM Plugin: Unable to load SDK");
            } else if (!useApi) {
              const flags = {};
              if (enableOm) {
                flags.enableOmidBeta = true;
              }
              if (enableCustomUi) {
                flags.customAdUi = true;
              }
              (_k = daiSdk == null ? void 0 : daiSdk.DaiSdkSettings) == null ? void 0 : _k.setFeatureFlags(flags);
            }
            const playheadInterface = useApi ? avia2.Util.createSimpleVideoInterface() : dom.video;
            if (!ssaiAdService) {
              ssaiAdService = new DaiAdService(
                context,
                useApi ? DaiProxyApi : daiSdk,
                playheadInterface
              );
            }
            adapter = new DaiAdAdapter({
              enableOm: enableOm && !useApi,
              playheadInterface,
              presentationContainer: null,
              autoplayState: {
                muted: context.muted,
                autoplay: context.autoplay
              },
              adService: ssaiAdService,
              breakDetectionWindow: (_l = ad.ssai) == null ? void 0 : _l.breakDetectionWindow
            }, context);
          }
          if (useCsai) {
            if (!((_n = (_m = system.global.google) == null ? void 0 : _m.ima) == null ? void 0 : _n.AdsRequest)) {
              const url = ((_o = options2.dependencies) == null ? void 0 : _o.ima) || `//imasdk.googleapis.com/js/sdkloader/ima3${debugSuffix}.js`;
              yield avia2.Util.loadScript(
                { url },
                playerOptions,
                () => {
                  var _a2;
                  return (_a2 = system.global.google) == null ? void 0 : _a2.ima;
                }
              );
            }
            if (enableOm) {
              (_r = (_q = (_p = system.global.google) == null ? void 0 : _p.ima) == null ? void 0 : _q.settings) == null ? void 0 : _r.setFeatureFlags({ "enableOmidBeta": true });
            }
            if (!csaiAdService) {
              csaiAdService = new ImaAdService(context, options2.imaVpaidMode, enableOm);
            }
            adapter = new ImaAdAdapter({
              playheadInterface: dom.video,
              presentationContainer: dom.main,
              autoplayState: {
                muted: context.muted,
                autoplay: context.autoplay
              },
              adService: csaiAdService
            }, context);
          }
          if (enableOm) {
            logger.info("OM is enabled");
          }
          if (!useApi && enableMoat) {
            logger.info("Moat SDK is enabled");
          }
          return adapter;
        });
      },
      isSupported: (context) => {
        const { resource } = context;
        const csaiValid = isValidCsaiConfig(resource.ad.csai);
        const ssaiValid = isValidSsaiConfig(resource.ad.ssai);
        return csaiValid || ssaiValid;
      }
    });
    return {
      getId() {
        return GAM;
      },
      destroy() {
        csaiAdService == null ? void 0 : csaiAdService.destroy();
        csaiAdService = null;
      },
      replaceAdTagParameters(adTagParameters) {
        var _a;
        (_a = adapter.replaceAdTagParameters) == null ? void 0 : _a.call(adapter, adTagParameters);
      }
    };
  });
}
const ID = GAM;
const createPlugin = createGamPlugin;
const plugin = gam;
exports.ClickThroughNavigation = ClickThroughNavigation;
exports.GAM = GAM;
exports.GamMeasurement = GamMeasurement;
exports.ID = ID;
exports.PLAYER_ACTIVE = PLAYER_ACTIVE;
exports.PLAYER_INACTIVE = PLAYER_INACTIVE;
exports.createGamPlugin = createGamPlugin;
exports.createPlugin = createPlugin;
exports.gam = gam;
exports.plugin = plugin;
//# sourceMappingURL=avia.gam.cjs.map
